/* eslint-disable */
// @ts-nocheck
"use client";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _OrganizationCreateAborted_error, _OrganizationCreateAborted_message, _OrganizationAddMemberAborted_error, _OrganizationAddMemberAborted_message, _OrganizationRemoveMemberAborted_error, _OrganizationRemoveMemberAborted_message, _OrganizationRemoveMemberFromOrgAndUserAborted_error, _OrganizationRemoveMemberFromOrgAndUserAborted_message, _OrganizationUpdateMemberAborted_error, _OrganizationUpdateMemberAborted_message, _OrganizationInviteMemberAborted_error, _OrganizationInviteMemberAborted_message, _OrganizationCancelInviteAborted_error, _OrganizationCancelInviteAborted_message, _OrganizationAcceptInviteAborted_error, _OrganizationAcceptInviteAborted_message, _OrganizationGetPendingInvitesAborted_error, _OrganizationGetPendingInvitesAborted_message, _OrganizationGetMembersAborted_error, _OrganizationGetMembersAborted_message, _OrganizationGetAborted_error, _OrganizationGetAborted_message, _OrganizationAddApplicationAborted_error, _OrganizationAddApplicationAborted_message, _OrganizationRemoveApplicationAborted_error, _OrganizationRemoveApplicationAborted_message, _OrganizationSubscribeAborted_error, _OrganizationSubscribeAborted_message, _OrganizationSetBillingExemptAborted_error, _OrganizationSetBillingExemptAborted_message, _OrganizationDetachFromStripeWorkflowAborted_error, _OrganizationDetachFromStripeWorkflowAborted_message, _OrganizationSubscribeWorkflowAborted_error, _OrganizationSubscribeWorkflowAborted_message, _OrganizationSubscriptionAborted_error, _OrganizationSubscriptionAborted_message, _OrganizationRedeemCreditCodeAborted_error, _OrganizationRedeemCreditCodeAborted_message, _OrganizationGrantCreditWorkflowAborted_error, _OrganizationGrantCreditWorkflowAborted_message, _OrganizationNotifyCreditDepletionAborted_error, _OrganizationNotifyCreditDepletionAborted_message, _OrganizationUpdateSubscriptionAborted_error, _OrganizationUpdateSubscriptionAborted_message, _OrganizationEnqueueWebhookEventAborted_error, _OrganizationEnqueueWebhookEventAborted_message, _OrganizationUpdateApplicationAborted_error, _OrganizationUpdateApplicationAborted_message, _OrganizationUpdateCardAborted_error, _OrganizationUpdateCardAborted_message, _OrganizationUpdateCardWorkflowAborted_error, _OrganizationUpdateCardWorkflowAborted_message, _OrganizationStripeWebhookWorkflowAborted_error, _OrganizationStripeWebhookWorkflowAborted_message, _OrganizationReconcileWithStripeAborted_error, _OrganizationReconcileWithStripeAborted_message, _OrganizationBeginGracePeriodAborted_error, _OrganizationBeginGracePeriodAborted_message, _OrganizationEndGracePeriodAborted_error, _OrganizationEndGracePeriodAborted_message, _OrganizationEnforceGracePeriodExpiryAborted_error, _OrganizationEnforceGracePeriodExpiryAborted_message, _OrganizationNotifyGracePeriodAborted_error, _OrganizationNotifyGracePeriodAborted_message, _OrganizationNotifyTeamAborted_error, _OrganizationNotifyTeamAborted_message, _OrganizationListApplicationsAborted_error, _OrganizationListApplicationsAborted_message, _OrganizationPinApplicationAborted_error, _OrganizationPinApplicationAborted_message, _OrganizationUnpinApplicationAborted_error, _OrganizationUnpinApplicationAborted_message;
import * as protobuf_es from "@bufbuild/protobuf";
import * as reboot_react from "@reboot-dev/reboot-react";
import * as reboot_web from "@reboot-dev/reboot-web";
import * as reboot_api from "@reboot-dev/reboot-api";
import React, { useEffect, useMemo, useRef, useState, } from "react";
import { v4 as uuidv4 } from "uuid";
import { useDefaultStateIds, useRefreshBearerToken } from "@reboot-dev/reboot-react/internal";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './organization_pb.js'
//
// You can resolve this by passing --react-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import { Organization as OrganizationProto, } from "./organization_pb.js";
import * as organization_pb from "./organization_pb.js";
// Additionally re-export all messages_and_enums from the pb module.
export { OrganizationMember, PendingInvite, Subscription, OpenInvoice, Card, OrganizationApplication, SubscriptionItem, CreateRequest, CreateResponse, AddMemberRequest, AddMemberResponse, RemoveMemberRequest, RemoveMemberResponse, UpdateMemberRequest, UpdateMemberResponse, InviteMemberRequest, InviteMemberResponse, CancelInviteRequest, CancelInviteResponse, AcceptInviteRequest, AcceptInviteResponse, GetPendingInvitesRequest, GetPendingInvitesResponse, OrganizationMemberView, GetMembersRequest, GetMembersResponse, GetRequest, GetResponse, ListApplicationsRequest, ApplicationSummary, ListApplicationsResponse, PinApplicationRequest, PinApplicationResponse, UnpinApplicationRequest, UnpinApplicationResponse, AddApplicationRequest, AddApplicationResponse, RemoveApplicationRequest, RemoveApplicationResponse, SubscribeRequest, SubscribeResponse, SetBillingExemptRequest, SetBillingExemptResponse, DetachFromStripeWorkflowRequest, DetachFromStripeWorkflowResponse, SubscribeWorkflowRequest, SubscribeWorkflowResponse, SubscriptionRequest, SubscriptionResponse, RedeemCreditCodeRequest, RedeemCreditCodeResponse, GrantCreditWorkflowRequest, GrantCreditWorkflowResponse, NotifyCreditDepletionRequest, NotifyCreditDepletionResponse, UpdateSubscriptionRequest, UpdateSubscriptionResponse, BeginGracePeriodRequest, BeginGracePeriodResponse, EndGracePeriodRequest, EndGracePeriodResponse, EnforceGracePeriodExpiryRequest, EnforceGracePeriodExpiryResponse, NotifyGracePeriodRequest, NotifyGracePeriodResponse, NotifyTeamRequest, NotifyTeamResponse, EnqueueWebhookEventRequest, EnqueueWebhookEventResponse, UpdateApplicationRequest, UpdateApplicationResponse, UpdateCardRequest, UpdateCardResponse, UpdateCardWorkflowRequest, UpdateCardWorkflowResponse, StripeWebhookWorkflowRequest, StripeWebhookWorkflowResponse, ReconcileWithStripeRequest, ReconcileWithStripeResponse, InvalidInputError, InvalidOperationError, Role, GracePeriodStage, } from "./organization_pb.js";
// It is important that the following is a function, so we can lazily
// initialize the cache, so users who do not use offline cache do not
// see any logs about its initialization.
export const offlineCacheStorageType = () => reboot_web.offlineCache().offlineCacheStorageType;
reboot_api.check_bufbuild_protobuf_library(protobuf_es.Message);
const ERROR_TYPES = [
    // gRPC errors.
    reboot_api.errors_pb.Cancelled,
    reboot_api.errors_pb.Unknown,
    reboot_api.errors_pb.InvalidArgument,
    reboot_api.errors_pb.DeadlineExceeded,
    reboot_api.errors_pb.NotFound,
    reboot_api.errors_pb.AlreadyExists,
    reboot_api.errors_pb.PermissionDenied,
    reboot_api.errors_pb.ResourceExhausted,
    reboot_api.errors_pb.FailedPrecondition,
    reboot_api.errors_pb.Aborted,
    reboot_api.errors_pb.OutOfRange,
    reboot_api.errors_pb.Unimplemented,
    reboot_api.errors_pb.Internal,
    reboot_api.errors_pb.Unavailable,
    reboot_api.errors_pb.DataLoss,
    reboot_api.errors_pb.Unauthenticated,
    // Reboot errors.
    //
    // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
    reboot_api.errors_pb.StateAlreadyConstructed,
    reboot_api.errors_pb.StateNotConstructed,
    reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
    reboot_api.errors_pb.TransactionParticipantFailedToCommit,
    reboot_api.errors_pb.TransactionShouldRetry,
    reboot_api.errors_pb.UnknownService,
    reboot_api.errors_pb.UnknownTask,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationCreateRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.CreateRequest
        ? partialRequest
        : organization_pb.CreateRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationCreateRequestFromJsonString = (jsonRequest) => {
    return OrganizationCreateRequestFromProtobufShape(organization_pb.CreateRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationCreateRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.CreateRequest
        ? partialRequest
        : new organization_pb.CreateRequest(partialRequest);
};
const OrganizationCreateResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.CreateResponse
        ? partialResponse
        : organization_pb.CreateResponse.fromJson(partialResponse);
    return response;
};
const OrganizationCreateResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.CreateResponse
        ? partialResponse
        : new organization_pb.CreateResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationAddMemberRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.AddMemberRequest
        ? partialRequest
        : organization_pb.AddMemberRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationAddMemberRequestFromJsonString = (jsonRequest) => {
    return OrganizationAddMemberRequestFromProtobufShape(organization_pb.AddMemberRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationAddMemberRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.AddMemberRequest
        ? partialRequest
        : new organization_pb.AddMemberRequest(partialRequest);
};
const OrganizationAddMemberResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.AddMemberResponse
        ? partialResponse
        : organization_pb.AddMemberResponse.fromJson(partialResponse);
    return response;
};
const OrganizationAddMemberResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.AddMemberResponse
        ? partialResponse
        : new organization_pb.AddMemberResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationRemoveMemberRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.RemoveMemberRequest
        ? partialRequest
        : organization_pb.RemoveMemberRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationRemoveMemberRequestFromJsonString = (jsonRequest) => {
    return OrganizationRemoveMemberRequestFromProtobufShape(organization_pb.RemoveMemberRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationRemoveMemberRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.RemoveMemberRequest
        ? partialRequest
        : new organization_pb.RemoveMemberRequest(partialRequest);
};
const OrganizationRemoveMemberResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.RemoveMemberResponse
        ? partialResponse
        : organization_pb.RemoveMemberResponse.fromJson(partialResponse);
    return response;
};
const OrganizationRemoveMemberResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.RemoveMemberResponse
        ? partialResponse
        : new organization_pb.RemoveMemberResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationRemoveMemberFromOrgAndUserRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.RemoveMemberRequest
        ? partialRequest
        : organization_pb.RemoveMemberRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationRemoveMemberFromOrgAndUserRequestFromJsonString = (jsonRequest) => {
    return OrganizationRemoveMemberFromOrgAndUserRequestFromProtobufShape(organization_pb.RemoveMemberRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationRemoveMemberFromOrgAndUserRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.RemoveMemberRequest
        ? partialRequest
        : new organization_pb.RemoveMemberRequest(partialRequest);
};
const OrganizationRemoveMemberFromOrgAndUserResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.RemoveMemberResponse
        ? partialResponse
        : organization_pb.RemoveMemberResponse.fromJson(partialResponse);
    return response;
};
const OrganizationRemoveMemberFromOrgAndUserResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.RemoveMemberResponse
        ? partialResponse
        : new organization_pb.RemoveMemberResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationUpdateMemberRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.UpdateMemberRequest
        ? partialRequest
        : organization_pb.UpdateMemberRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationUpdateMemberRequestFromJsonString = (jsonRequest) => {
    return OrganizationUpdateMemberRequestFromProtobufShape(organization_pb.UpdateMemberRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationUpdateMemberRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.UpdateMemberRequest
        ? partialRequest
        : new organization_pb.UpdateMemberRequest(partialRequest);
};
const OrganizationUpdateMemberResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.UpdateMemberResponse
        ? partialResponse
        : organization_pb.UpdateMemberResponse.fromJson(partialResponse);
    return response;
};
const OrganizationUpdateMemberResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.UpdateMemberResponse
        ? partialResponse
        : new organization_pb.UpdateMemberResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationInviteMemberRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.InviteMemberRequest
        ? partialRequest
        : organization_pb.InviteMemberRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationInviteMemberRequestFromJsonString = (jsonRequest) => {
    return OrganizationInviteMemberRequestFromProtobufShape(organization_pb.InviteMemberRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationInviteMemberRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.InviteMemberRequest
        ? partialRequest
        : new organization_pb.InviteMemberRequest(partialRequest);
};
const OrganizationInviteMemberResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.InviteMemberResponse
        ? partialResponse
        : organization_pb.InviteMemberResponse.fromJson(partialResponse);
    return response;
};
const OrganizationInviteMemberResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.InviteMemberResponse
        ? partialResponse
        : new organization_pb.InviteMemberResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationCancelInviteRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.CancelInviteRequest
        ? partialRequest
        : organization_pb.CancelInviteRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationCancelInviteRequestFromJsonString = (jsonRequest) => {
    return OrganizationCancelInviteRequestFromProtobufShape(organization_pb.CancelInviteRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationCancelInviteRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.CancelInviteRequest
        ? partialRequest
        : new organization_pb.CancelInviteRequest(partialRequest);
};
const OrganizationCancelInviteResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.CancelInviteResponse
        ? partialResponse
        : organization_pb.CancelInviteResponse.fromJson(partialResponse);
    return response;
};
const OrganizationCancelInviteResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.CancelInviteResponse
        ? partialResponse
        : new organization_pb.CancelInviteResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationAcceptInviteRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.AcceptInviteRequest
        ? partialRequest
        : organization_pb.AcceptInviteRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationAcceptInviteRequestFromJsonString = (jsonRequest) => {
    return OrganizationAcceptInviteRequestFromProtobufShape(organization_pb.AcceptInviteRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationAcceptInviteRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.AcceptInviteRequest
        ? partialRequest
        : new organization_pb.AcceptInviteRequest(partialRequest);
};
const OrganizationAcceptInviteResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.AcceptInviteResponse
        ? partialResponse
        : organization_pb.AcceptInviteResponse.fromJson(partialResponse);
    return response;
};
const OrganizationAcceptInviteResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.AcceptInviteResponse
        ? partialResponse
        : new organization_pb.AcceptInviteResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationGetPendingInvitesRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.GetPendingInvitesRequest
        ? partialRequest
        : organization_pb.GetPendingInvitesRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationGetPendingInvitesRequestFromJsonString = (jsonRequest) => {
    return OrganizationGetPendingInvitesRequestFromProtobufShape(organization_pb.GetPendingInvitesRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationGetPendingInvitesRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.GetPendingInvitesRequest
        ? partialRequest
        : new organization_pb.GetPendingInvitesRequest(partialRequest);
};
const OrganizationGetPendingInvitesResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.GetPendingInvitesResponse
        ? partialResponse
        : organization_pb.GetPendingInvitesResponse.fromJson(partialResponse);
    return response;
};
const OrganizationGetPendingInvitesResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.GetPendingInvitesResponse
        ? partialResponse
        : new organization_pb.GetPendingInvitesResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationGetMembersRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.GetMembersRequest
        ? partialRequest
        : organization_pb.GetMembersRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationGetMembersRequestFromJsonString = (jsonRequest) => {
    return OrganizationGetMembersRequestFromProtobufShape(organization_pb.GetMembersRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationGetMembersRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.GetMembersRequest
        ? partialRequest
        : new organization_pb.GetMembersRequest(partialRequest);
};
const OrganizationGetMembersResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.GetMembersResponse
        ? partialResponse
        : organization_pb.GetMembersResponse.fromJson(partialResponse);
    return response;
};
const OrganizationGetMembersResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.GetMembersResponse
        ? partialResponse
        : new organization_pb.GetMembersResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationGetRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.GetRequest
        ? partialRequest
        : organization_pb.GetRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationGetRequestFromJsonString = (jsonRequest) => {
    return OrganizationGetRequestFromProtobufShape(organization_pb.GetRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationGetRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.GetRequest
        ? partialRequest
        : new organization_pb.GetRequest(partialRequest);
};
const OrganizationGetResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.GetResponse
        ? partialResponse
        : organization_pb.GetResponse.fromJson(partialResponse);
    return response;
};
const OrganizationGetResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.GetResponse
        ? partialResponse
        : new organization_pb.GetResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationAddApplicationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.AddApplicationRequest
        ? partialRequest
        : organization_pb.AddApplicationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationAddApplicationRequestFromJsonString = (jsonRequest) => {
    return OrganizationAddApplicationRequestFromProtobufShape(organization_pb.AddApplicationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationAddApplicationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.AddApplicationRequest
        ? partialRequest
        : new organization_pb.AddApplicationRequest(partialRequest);
};
const OrganizationAddApplicationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.AddApplicationResponse
        ? partialResponse
        : organization_pb.AddApplicationResponse.fromJson(partialResponse);
    return response;
};
const OrganizationAddApplicationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.AddApplicationResponse
        ? partialResponse
        : new organization_pb.AddApplicationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationRemoveApplicationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.RemoveApplicationRequest
        ? partialRequest
        : organization_pb.RemoveApplicationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationRemoveApplicationRequestFromJsonString = (jsonRequest) => {
    return OrganizationRemoveApplicationRequestFromProtobufShape(organization_pb.RemoveApplicationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationRemoveApplicationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.RemoveApplicationRequest
        ? partialRequest
        : new organization_pb.RemoveApplicationRequest(partialRequest);
};
const OrganizationRemoveApplicationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.RemoveApplicationResponse
        ? partialResponse
        : organization_pb.RemoveApplicationResponse.fromJson(partialResponse);
    return response;
};
const OrganizationRemoveApplicationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.RemoveApplicationResponse
        ? partialResponse
        : new organization_pb.RemoveApplicationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationSubscribeRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.SubscribeRequest
        ? partialRequest
        : organization_pb.SubscribeRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationSubscribeRequestFromJsonString = (jsonRequest) => {
    return OrganizationSubscribeRequestFromProtobufShape(organization_pb.SubscribeRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationSubscribeRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.SubscribeRequest
        ? partialRequest
        : new organization_pb.SubscribeRequest(partialRequest);
};
const OrganizationSubscribeResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.SubscribeResponse
        ? partialResponse
        : organization_pb.SubscribeResponse.fromJson(partialResponse);
    return response;
};
const OrganizationSubscribeResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.SubscribeResponse
        ? partialResponse
        : new organization_pb.SubscribeResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationSetBillingExemptRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.SetBillingExemptRequest
        ? partialRequest
        : organization_pb.SetBillingExemptRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationSetBillingExemptRequestFromJsonString = (jsonRequest) => {
    return OrganizationSetBillingExemptRequestFromProtobufShape(organization_pb.SetBillingExemptRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationSetBillingExemptRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.SetBillingExemptRequest
        ? partialRequest
        : new organization_pb.SetBillingExemptRequest(partialRequest);
};
const OrganizationSetBillingExemptResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.SetBillingExemptResponse
        ? partialResponse
        : organization_pb.SetBillingExemptResponse.fromJson(partialResponse);
    return response;
};
const OrganizationSetBillingExemptResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.SetBillingExemptResponse
        ? partialResponse
        : new organization_pb.SetBillingExemptResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationDetachFromStripeWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.DetachFromStripeWorkflowRequest
        ? partialRequest
        : organization_pb.DetachFromStripeWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationDetachFromStripeWorkflowRequestFromJsonString = (jsonRequest) => {
    return OrganizationDetachFromStripeWorkflowRequestFromProtobufShape(organization_pb.DetachFromStripeWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationDetachFromStripeWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.DetachFromStripeWorkflowRequest
        ? partialRequest
        : new organization_pb.DetachFromStripeWorkflowRequest(partialRequest);
};
const OrganizationDetachFromStripeWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.DetachFromStripeWorkflowResponse
        ? partialResponse
        : organization_pb.DetachFromStripeWorkflowResponse.fromJson(partialResponse);
    return response;
};
const OrganizationDetachFromStripeWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.DetachFromStripeWorkflowResponse
        ? partialResponse
        : new organization_pb.DetachFromStripeWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationSubscribeWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.SubscribeWorkflowRequest
        ? partialRequest
        : organization_pb.SubscribeWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationSubscribeWorkflowRequestFromJsonString = (jsonRequest) => {
    return OrganizationSubscribeWorkflowRequestFromProtobufShape(organization_pb.SubscribeWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationSubscribeWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.SubscribeWorkflowRequest
        ? partialRequest
        : new organization_pb.SubscribeWorkflowRequest(partialRequest);
};
const OrganizationSubscribeWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.SubscribeWorkflowResponse
        ? partialResponse
        : organization_pb.SubscribeWorkflowResponse.fromJson(partialResponse);
    return response;
};
const OrganizationSubscribeWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.SubscribeWorkflowResponse
        ? partialResponse
        : new organization_pb.SubscribeWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationSubscriptionRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.SubscriptionRequest
        ? partialRequest
        : organization_pb.SubscriptionRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationSubscriptionRequestFromJsonString = (jsonRequest) => {
    return OrganizationSubscriptionRequestFromProtobufShape(organization_pb.SubscriptionRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationSubscriptionRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.SubscriptionRequest
        ? partialRequest
        : new organization_pb.SubscriptionRequest(partialRequest);
};
const OrganizationSubscriptionResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.SubscriptionResponse
        ? partialResponse
        : organization_pb.SubscriptionResponse.fromJson(partialResponse);
    return response;
};
const OrganizationSubscriptionResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.SubscriptionResponse
        ? partialResponse
        : new organization_pb.SubscriptionResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationRedeemCreditCodeRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.RedeemCreditCodeRequest
        ? partialRequest
        : organization_pb.RedeemCreditCodeRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationRedeemCreditCodeRequestFromJsonString = (jsonRequest) => {
    return OrganizationRedeemCreditCodeRequestFromProtobufShape(organization_pb.RedeemCreditCodeRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationRedeemCreditCodeRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.RedeemCreditCodeRequest
        ? partialRequest
        : new organization_pb.RedeemCreditCodeRequest(partialRequest);
};
const OrganizationRedeemCreditCodeResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.RedeemCreditCodeResponse
        ? partialResponse
        : organization_pb.RedeemCreditCodeResponse.fromJson(partialResponse);
    return response;
};
const OrganizationRedeemCreditCodeResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.RedeemCreditCodeResponse
        ? partialResponse
        : new organization_pb.RedeemCreditCodeResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationGrantCreditWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.GrantCreditWorkflowRequest
        ? partialRequest
        : organization_pb.GrantCreditWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationGrantCreditWorkflowRequestFromJsonString = (jsonRequest) => {
    return OrganizationGrantCreditWorkflowRequestFromProtobufShape(organization_pb.GrantCreditWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationGrantCreditWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.GrantCreditWorkflowRequest
        ? partialRequest
        : new organization_pb.GrantCreditWorkflowRequest(partialRequest);
};
const OrganizationGrantCreditWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.GrantCreditWorkflowResponse
        ? partialResponse
        : organization_pb.GrantCreditWorkflowResponse.fromJson(partialResponse);
    return response;
};
const OrganizationGrantCreditWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.GrantCreditWorkflowResponse
        ? partialResponse
        : new organization_pb.GrantCreditWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationNotifyCreditDepletionRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.NotifyCreditDepletionRequest
        ? partialRequest
        : organization_pb.NotifyCreditDepletionRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationNotifyCreditDepletionRequestFromJsonString = (jsonRequest) => {
    return OrganizationNotifyCreditDepletionRequestFromProtobufShape(organization_pb.NotifyCreditDepletionRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationNotifyCreditDepletionRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.NotifyCreditDepletionRequest
        ? partialRequest
        : new organization_pb.NotifyCreditDepletionRequest(partialRequest);
};
const OrganizationNotifyCreditDepletionResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.NotifyCreditDepletionResponse
        ? partialResponse
        : organization_pb.NotifyCreditDepletionResponse.fromJson(partialResponse);
    return response;
};
const OrganizationNotifyCreditDepletionResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.NotifyCreditDepletionResponse
        ? partialResponse
        : new organization_pb.NotifyCreditDepletionResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationUpdateSubscriptionRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.UpdateSubscriptionRequest
        ? partialRequest
        : organization_pb.UpdateSubscriptionRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationUpdateSubscriptionRequestFromJsonString = (jsonRequest) => {
    return OrganizationUpdateSubscriptionRequestFromProtobufShape(organization_pb.UpdateSubscriptionRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationUpdateSubscriptionRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.UpdateSubscriptionRequest
        ? partialRequest
        : new organization_pb.UpdateSubscriptionRequest(partialRequest);
};
const OrganizationUpdateSubscriptionResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.UpdateSubscriptionResponse
        ? partialResponse
        : organization_pb.UpdateSubscriptionResponse.fromJson(partialResponse);
    return response;
};
const OrganizationUpdateSubscriptionResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.UpdateSubscriptionResponse
        ? partialResponse
        : new organization_pb.UpdateSubscriptionResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationEnqueueWebhookEventRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.EnqueueWebhookEventRequest
        ? partialRequest
        : organization_pb.EnqueueWebhookEventRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationEnqueueWebhookEventRequestFromJsonString = (jsonRequest) => {
    return OrganizationEnqueueWebhookEventRequestFromProtobufShape(organization_pb.EnqueueWebhookEventRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationEnqueueWebhookEventRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.EnqueueWebhookEventRequest
        ? partialRequest
        : new organization_pb.EnqueueWebhookEventRequest(partialRequest);
};
const OrganizationEnqueueWebhookEventResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.EnqueueWebhookEventResponse
        ? partialResponse
        : organization_pb.EnqueueWebhookEventResponse.fromJson(partialResponse);
    return response;
};
const OrganizationEnqueueWebhookEventResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.EnqueueWebhookEventResponse
        ? partialResponse
        : new organization_pb.EnqueueWebhookEventResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationUpdateApplicationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.UpdateApplicationRequest
        ? partialRequest
        : organization_pb.UpdateApplicationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationUpdateApplicationRequestFromJsonString = (jsonRequest) => {
    return OrganizationUpdateApplicationRequestFromProtobufShape(organization_pb.UpdateApplicationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationUpdateApplicationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.UpdateApplicationRequest
        ? partialRequest
        : new organization_pb.UpdateApplicationRequest(partialRequest);
};
const OrganizationUpdateApplicationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.UpdateApplicationResponse
        ? partialResponse
        : organization_pb.UpdateApplicationResponse.fromJson(partialResponse);
    return response;
};
const OrganizationUpdateApplicationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.UpdateApplicationResponse
        ? partialResponse
        : new organization_pb.UpdateApplicationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationUpdateCardRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.UpdateCardRequest
        ? partialRequest
        : organization_pb.UpdateCardRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationUpdateCardRequestFromJsonString = (jsonRequest) => {
    return OrganizationUpdateCardRequestFromProtobufShape(organization_pb.UpdateCardRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationUpdateCardRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.UpdateCardRequest
        ? partialRequest
        : new organization_pb.UpdateCardRequest(partialRequest);
};
const OrganizationUpdateCardResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.UpdateCardResponse
        ? partialResponse
        : organization_pb.UpdateCardResponse.fromJson(partialResponse);
    return response;
};
const OrganizationUpdateCardResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.UpdateCardResponse
        ? partialResponse
        : new organization_pb.UpdateCardResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationUpdateCardWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.UpdateCardWorkflowRequest
        ? partialRequest
        : organization_pb.UpdateCardWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationUpdateCardWorkflowRequestFromJsonString = (jsonRequest) => {
    return OrganizationUpdateCardWorkflowRequestFromProtobufShape(organization_pb.UpdateCardWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationUpdateCardWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.UpdateCardWorkflowRequest
        ? partialRequest
        : new organization_pb.UpdateCardWorkflowRequest(partialRequest);
};
const OrganizationUpdateCardWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.UpdateCardWorkflowResponse
        ? partialResponse
        : organization_pb.UpdateCardWorkflowResponse.fromJson(partialResponse);
    return response;
};
const OrganizationUpdateCardWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.UpdateCardWorkflowResponse
        ? partialResponse
        : new organization_pb.UpdateCardWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationStripeWebhookWorkflowRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.StripeWebhookWorkflowRequest
        ? partialRequest
        : organization_pb.StripeWebhookWorkflowRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationStripeWebhookWorkflowRequestFromJsonString = (jsonRequest) => {
    return OrganizationStripeWebhookWorkflowRequestFromProtobufShape(organization_pb.StripeWebhookWorkflowRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationStripeWebhookWorkflowRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.StripeWebhookWorkflowRequest
        ? partialRequest
        : new organization_pb.StripeWebhookWorkflowRequest(partialRequest);
};
const OrganizationStripeWebhookWorkflowResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.StripeWebhookWorkflowResponse
        ? partialResponse
        : organization_pb.StripeWebhookWorkflowResponse.fromJson(partialResponse);
    return response;
};
const OrganizationStripeWebhookWorkflowResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.StripeWebhookWorkflowResponse
        ? partialResponse
        : new organization_pb.StripeWebhookWorkflowResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationReconcileWithStripeRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.ReconcileWithStripeRequest
        ? partialRequest
        : organization_pb.ReconcileWithStripeRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationReconcileWithStripeRequestFromJsonString = (jsonRequest) => {
    return OrganizationReconcileWithStripeRequestFromProtobufShape(organization_pb.ReconcileWithStripeRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationReconcileWithStripeRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.ReconcileWithStripeRequest
        ? partialRequest
        : new organization_pb.ReconcileWithStripeRequest(partialRequest);
};
const OrganizationReconcileWithStripeResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.ReconcileWithStripeResponse
        ? partialResponse
        : organization_pb.ReconcileWithStripeResponse.fromJson(partialResponse);
    return response;
};
const OrganizationReconcileWithStripeResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.ReconcileWithStripeResponse
        ? partialResponse
        : new organization_pb.ReconcileWithStripeResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationBeginGracePeriodRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.BeginGracePeriodRequest
        ? partialRequest
        : organization_pb.BeginGracePeriodRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationBeginGracePeriodRequestFromJsonString = (jsonRequest) => {
    return OrganizationBeginGracePeriodRequestFromProtobufShape(organization_pb.BeginGracePeriodRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationBeginGracePeriodRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.BeginGracePeriodRequest
        ? partialRequest
        : new organization_pb.BeginGracePeriodRequest(partialRequest);
};
const OrganizationBeginGracePeriodResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.BeginGracePeriodResponse
        ? partialResponse
        : organization_pb.BeginGracePeriodResponse.fromJson(partialResponse);
    return response;
};
const OrganizationBeginGracePeriodResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.BeginGracePeriodResponse
        ? partialResponse
        : new organization_pb.BeginGracePeriodResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationEndGracePeriodRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.EndGracePeriodRequest
        ? partialRequest
        : organization_pb.EndGracePeriodRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationEndGracePeriodRequestFromJsonString = (jsonRequest) => {
    return OrganizationEndGracePeriodRequestFromProtobufShape(organization_pb.EndGracePeriodRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationEndGracePeriodRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.EndGracePeriodRequest
        ? partialRequest
        : new organization_pb.EndGracePeriodRequest(partialRequest);
};
const OrganizationEndGracePeriodResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.EndGracePeriodResponse
        ? partialResponse
        : organization_pb.EndGracePeriodResponse.fromJson(partialResponse);
    return response;
};
const OrganizationEndGracePeriodResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.EndGracePeriodResponse
        ? partialResponse
        : new organization_pb.EndGracePeriodResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationEnforceGracePeriodExpiryRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.EnforceGracePeriodExpiryRequest
        ? partialRequest
        : organization_pb.EnforceGracePeriodExpiryRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationEnforceGracePeriodExpiryRequestFromJsonString = (jsonRequest) => {
    return OrganizationEnforceGracePeriodExpiryRequestFromProtobufShape(organization_pb.EnforceGracePeriodExpiryRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationEnforceGracePeriodExpiryRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.EnforceGracePeriodExpiryRequest
        ? partialRequest
        : new organization_pb.EnforceGracePeriodExpiryRequest(partialRequest);
};
const OrganizationEnforceGracePeriodExpiryResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.EnforceGracePeriodExpiryResponse
        ? partialResponse
        : organization_pb.EnforceGracePeriodExpiryResponse.fromJson(partialResponse);
    return response;
};
const OrganizationEnforceGracePeriodExpiryResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.EnforceGracePeriodExpiryResponse
        ? partialResponse
        : new organization_pb.EnforceGracePeriodExpiryResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationNotifyGracePeriodRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.NotifyGracePeriodRequest
        ? partialRequest
        : organization_pb.NotifyGracePeriodRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationNotifyGracePeriodRequestFromJsonString = (jsonRequest) => {
    return OrganizationNotifyGracePeriodRequestFromProtobufShape(organization_pb.NotifyGracePeriodRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationNotifyGracePeriodRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.NotifyGracePeriodRequest
        ? partialRequest
        : new organization_pb.NotifyGracePeriodRequest(partialRequest);
};
const OrganizationNotifyGracePeriodResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.NotifyGracePeriodResponse
        ? partialResponse
        : organization_pb.NotifyGracePeriodResponse.fromJson(partialResponse);
    return response;
};
const OrganizationNotifyGracePeriodResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.NotifyGracePeriodResponse
        ? partialResponse
        : new organization_pb.NotifyGracePeriodResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationNotifyTeamRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.NotifyTeamRequest
        ? partialRequest
        : organization_pb.NotifyTeamRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationNotifyTeamRequestFromJsonString = (jsonRequest) => {
    return OrganizationNotifyTeamRequestFromProtobufShape(organization_pb.NotifyTeamRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationNotifyTeamRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.NotifyTeamRequest
        ? partialRequest
        : new organization_pb.NotifyTeamRequest(partialRequest);
};
const OrganizationNotifyTeamResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.NotifyTeamResponse
        ? partialResponse
        : organization_pb.NotifyTeamResponse.fromJson(partialResponse);
    return response;
};
const OrganizationNotifyTeamResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.NotifyTeamResponse
        ? partialResponse
        : new organization_pb.NotifyTeamResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationListApplicationsRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.ListApplicationsRequest
        ? partialRequest
        : organization_pb.ListApplicationsRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationListApplicationsRequestFromJsonString = (jsonRequest) => {
    return OrganizationListApplicationsRequestFromProtobufShape(organization_pb.ListApplicationsRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationListApplicationsRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.ListApplicationsRequest
        ? partialRequest
        : new organization_pb.ListApplicationsRequest(partialRequest);
};
const OrganizationListApplicationsResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.ListApplicationsResponse
        ? partialResponse
        : organization_pb.ListApplicationsResponse.fromJson(partialResponse);
    return response;
};
const OrganizationListApplicationsResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.ListApplicationsResponse
        ? partialResponse
        : new organization_pb.ListApplicationsResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationPinApplicationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.PinApplicationRequest
        ? partialRequest
        : organization_pb.PinApplicationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationPinApplicationRequestFromJsonString = (jsonRequest) => {
    return OrganizationPinApplicationRequestFromProtobufShape(organization_pb.PinApplicationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationPinApplicationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.PinApplicationRequest
        ? partialRequest
        : new organization_pb.PinApplicationRequest(partialRequest);
};
const OrganizationPinApplicationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.PinApplicationResponse
        ? partialResponse
        : organization_pb.PinApplicationResponse.fromJson(partialResponse);
    return response;
};
const OrganizationPinApplicationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.PinApplicationResponse
        ? partialResponse
        : new organization_pb.PinApplicationResponse(partialResponse);
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const OrganizationUnpinApplicationRequestFromProtobufShape = (partialRequest) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const request = partialRequest instanceof organization_pb.UnpinApplicationRequest
        ? partialRequest
        : organization_pb.UnpinApplicationRequest.fromJson(partialRequest);
    return request;
};
// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const OrganizationUnpinApplicationRequestFromJsonString = (jsonRequest) => {
    return OrganizationUnpinApplicationRequestFromProtobufShape(organization_pb.UnpinApplicationRequest.fromJsonString(jsonRequest));
};
// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const OrganizationUnpinApplicationRequestToProtobuf = (partialRequest) => {
    return partialRequest instanceof organization_pb.UnpinApplicationRequest
        ? partialRequest
        : new organization_pb.UnpinApplicationRequest(partialRequest);
};
const OrganizationUnpinApplicationResponseFromProtobufShape = (partialResponse) => {
    // TOOD: update `protoToZod()` to actually work from
    // any objects that match the shape, not just protobuf instances,
    // and then we won't need to first call `fromJson()` here.
    const response = partialResponse instanceof organization_pb.UnpinApplicationResponse
        ? partialResponse
        : organization_pb.UnpinApplicationResponse.fromJson(partialResponse);
    return response;
};
const OrganizationUnpinApplicationResponseToProtobuf = (partialResponse) => {
    return partialResponse instanceof organization_pb.UnpinApplicationResponse
        ? partialResponse
        : new organization_pb.UnpinApplicationResponse(partialResponse);
};
const ORGANIZATION_CREATE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidInputError,
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationCreateAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_CREATE_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationCreateAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationCreateAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationCreateAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationCreateAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationCreateAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationCreateAborted_error.set(this, void 0);
        _OrganizationCreateAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationCreateAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationCreateAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationCreateAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationCreateAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationCreateAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationCreateAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationCreateAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationCreateAborted_error, "f");
    }
}
_OrganizationCreateAborted_error = new WeakMap(), _OrganizationCreateAborted_message = new WeakMap();
const ORGANIZATION_ADD_MEMBER_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidInputError,
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationAddMemberAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_ADD_MEMBER_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationAddMemberAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationAddMemberAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationAddMemberAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationAddMemberAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationAddMemberAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationAddMemberAborted_error.set(this, void 0);
        _OrganizationAddMemberAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationAddMemberAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationAddMemberAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationAddMemberAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationAddMemberAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationAddMemberAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationAddMemberAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationAddMemberAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationAddMemberAborted_error, "f");
    }
}
_OrganizationAddMemberAborted_error = new WeakMap(), _OrganizationAddMemberAborted_message = new WeakMap();
const ORGANIZATION_REMOVE_MEMBER_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidInputError,
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationRemoveMemberAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_REMOVE_MEMBER_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationRemoveMemberAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationRemoveMemberAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationRemoveMemberAborted_error.set(this, void 0);
        _OrganizationRemoveMemberAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationRemoveMemberAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationRemoveMemberAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationRemoveMemberAborted_error, "f");
    }
}
_OrganizationRemoveMemberAborted_error = new WeakMap(), _OrganizationRemoveMemberAborted_message = new WeakMap();
const ORGANIZATION_REMOVE_MEMBER_FROM_ORG_AND_USER_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidInputError,
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationRemoveMemberFromOrgAndUserAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_REMOVE_MEMBER_FROM_ORG_AND_USER_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationRemoveMemberFromOrgAndUserAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationRemoveMemberFromOrgAndUserAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationRemoveMemberFromOrgAndUserAborted_error.set(this, void 0);
        _OrganizationRemoveMemberFromOrgAndUserAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationRemoveMemberFromOrgAndUserAborted_error, "f");
    }
}
_OrganizationRemoveMemberFromOrgAndUserAborted_error = new WeakMap(), _OrganizationRemoveMemberFromOrgAndUserAborted_message = new WeakMap();
const ORGANIZATION_UPDATE_MEMBER_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidInputError,
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationUpdateMemberAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_UPDATE_MEMBER_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationUpdateMemberAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationUpdateMemberAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationUpdateMemberAborted_error.set(this, void 0);
        _OrganizationUpdateMemberAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationUpdateMemberAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationUpdateMemberAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationUpdateMemberAborted_error, "f");
    }
}
_OrganizationUpdateMemberAborted_error = new WeakMap(), _OrganizationUpdateMemberAborted_message = new WeakMap();
const ORGANIZATION_INVITE_MEMBER_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidInputError,
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationInviteMemberAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_INVITE_MEMBER_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationInviteMemberAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationInviteMemberAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationInviteMemberAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationInviteMemberAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationInviteMemberAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationInviteMemberAborted_error.set(this, void 0);
        _OrganizationInviteMemberAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationInviteMemberAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationInviteMemberAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationInviteMemberAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationInviteMemberAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationInviteMemberAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationInviteMemberAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationInviteMemberAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationInviteMemberAborted_error, "f");
    }
}
_OrganizationInviteMemberAborted_error = new WeakMap(), _OrganizationInviteMemberAborted_message = new WeakMap();
const ORGANIZATION_CANCEL_INVITE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationCancelInviteAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_CANCEL_INVITE_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationCancelInviteAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationCancelInviteAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationCancelInviteAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationCancelInviteAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationCancelInviteAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationCancelInviteAborted_error.set(this, void 0);
        _OrganizationCancelInviteAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationCancelInviteAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationCancelInviteAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationCancelInviteAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationCancelInviteAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationCancelInviteAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationCancelInviteAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationCancelInviteAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationCancelInviteAborted_error, "f");
    }
}
_OrganizationCancelInviteAborted_error = new WeakMap(), _OrganizationCancelInviteAborted_message = new WeakMap();
const ORGANIZATION_ACCEPT_INVITE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationAcceptInviteAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_ACCEPT_INVITE_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationAcceptInviteAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationAcceptInviteAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationAcceptInviteAborted_error.set(this, void 0);
        _OrganizationAcceptInviteAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationAcceptInviteAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationAcceptInviteAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationAcceptInviteAborted_error, "f");
    }
}
_OrganizationAcceptInviteAborted_error = new WeakMap(), _OrganizationAcceptInviteAborted_message = new WeakMap();
const ORGANIZATION_GET_PENDING_INVITES_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationGetPendingInvitesAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_GET_PENDING_INVITES_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationGetPendingInvitesAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationGetPendingInvitesAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationGetPendingInvitesAborted_error.set(this, void 0);
        _OrganizationGetPendingInvitesAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationGetPendingInvitesAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationGetPendingInvitesAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationGetPendingInvitesAborted_error, "f");
    }
}
_OrganizationGetPendingInvitesAborted_error = new WeakMap(), _OrganizationGetPendingInvitesAborted_message = new WeakMap();
const ORGANIZATION_GET_MEMBERS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationGetMembersAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_GET_MEMBERS_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationGetMembersAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationGetMembersAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationGetMembersAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationGetMembersAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationGetMembersAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationGetMembersAborted_error.set(this, void 0);
        _OrganizationGetMembersAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationGetMembersAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationGetMembersAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationGetMembersAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationGetMembersAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationGetMembersAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationGetMembersAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationGetMembersAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationGetMembersAborted_error, "f");
    }
}
_OrganizationGetMembersAborted_error = new WeakMap(), _OrganizationGetMembersAborted_message = new WeakMap();
const ORGANIZATION_GET_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationGetAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_GET_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationGetAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationGetAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationGetAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationGetAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationGetAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationGetAborted_error.set(this, void 0);
        _OrganizationGetAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationGetAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationGetAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationGetAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationGetAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationGetAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationGetAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationGetAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationGetAborted_error, "f");
    }
}
_OrganizationGetAborted_error = new WeakMap(), _OrganizationGetAborted_message = new WeakMap();
const ORGANIZATION_ADD_APPLICATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationAddApplicationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_ADD_APPLICATION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationAddApplicationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationAddApplicationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationAddApplicationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationAddApplicationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationAddApplicationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationAddApplicationAborted_error.set(this, void 0);
        _OrganizationAddApplicationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationAddApplicationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationAddApplicationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationAddApplicationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationAddApplicationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationAddApplicationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationAddApplicationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationAddApplicationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationAddApplicationAborted_error, "f");
    }
}
_OrganizationAddApplicationAborted_error = new WeakMap(), _OrganizationAddApplicationAborted_message = new WeakMap();
const ORGANIZATION_REMOVE_APPLICATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationRemoveApplicationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_REMOVE_APPLICATION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationRemoveApplicationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationRemoveApplicationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationRemoveApplicationAborted_error.set(this, void 0);
        _OrganizationRemoveApplicationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationRemoveApplicationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationRemoveApplicationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationRemoveApplicationAborted_error, "f");
    }
}
_OrganizationRemoveApplicationAborted_error = new WeakMap(), _OrganizationRemoveApplicationAborted_message = new WeakMap();
const ORGANIZATION_SUBSCRIBE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationSubscribeAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_SUBSCRIBE_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationSubscribeAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationSubscribeAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationSubscribeAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationSubscribeAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationSubscribeAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationSubscribeAborted_error.set(this, void 0);
        _OrganizationSubscribeAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationSubscribeAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationSubscribeAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationSubscribeAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationSubscribeAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationSubscribeAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationSubscribeAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationSubscribeAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationSubscribeAborted_error, "f");
    }
}
_OrganizationSubscribeAborted_error = new WeakMap(), _OrganizationSubscribeAborted_message = new WeakMap();
const ORGANIZATION_SET_BILLING_EXEMPT_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationSetBillingExemptAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_SET_BILLING_EXEMPT_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationSetBillingExemptAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationSetBillingExemptAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationSetBillingExemptAborted_error.set(this, void 0);
        _OrganizationSetBillingExemptAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationSetBillingExemptAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationSetBillingExemptAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationSetBillingExemptAborted_error, "f");
    }
}
_OrganizationSetBillingExemptAborted_error = new WeakMap(), _OrganizationSetBillingExemptAborted_message = new WeakMap();
const ORGANIZATION_DETACH_FROM_STRIPE_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationDetachFromStripeWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_DETACH_FROM_STRIPE_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationDetachFromStripeWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationDetachFromStripeWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationDetachFromStripeWorkflowAborted_error.set(this, void 0);
        _OrganizationDetachFromStripeWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationDetachFromStripeWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationDetachFromStripeWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationDetachFromStripeWorkflowAborted_error, "f");
    }
}
_OrganizationDetachFromStripeWorkflowAborted_error = new WeakMap(), _OrganizationDetachFromStripeWorkflowAborted_message = new WeakMap();
const ORGANIZATION_SUBSCRIBE_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationSubscribeWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_SUBSCRIBE_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationSubscribeWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationSubscribeWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationSubscribeWorkflowAborted_error.set(this, void 0);
        _OrganizationSubscribeWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationSubscribeWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationSubscribeWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationSubscribeWorkflowAborted_error, "f");
    }
}
_OrganizationSubscribeWorkflowAborted_error = new WeakMap(), _OrganizationSubscribeWorkflowAborted_message = new WeakMap();
const ORGANIZATION_SUBSCRIPTION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationSubscriptionAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_SUBSCRIPTION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationSubscriptionAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationSubscriptionAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationSubscriptionAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationSubscriptionAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationSubscriptionAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationSubscriptionAborted_error.set(this, void 0);
        _OrganizationSubscriptionAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationSubscriptionAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationSubscriptionAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationSubscriptionAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationSubscriptionAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationSubscriptionAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationSubscriptionAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationSubscriptionAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationSubscriptionAborted_error, "f");
    }
}
_OrganizationSubscriptionAborted_error = new WeakMap(), _OrganizationSubscriptionAborted_message = new WeakMap();
const ORGANIZATION_REDEEM_CREDIT_CODE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidInputError,
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationRedeemCreditCodeAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_REDEEM_CREDIT_CODE_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationRedeemCreditCodeAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationRedeemCreditCodeAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationRedeemCreditCodeAborted_error.set(this, void 0);
        _OrganizationRedeemCreditCodeAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationRedeemCreditCodeAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationRedeemCreditCodeAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationRedeemCreditCodeAborted_error, "f");
    }
}
_OrganizationRedeemCreditCodeAborted_error = new WeakMap(), _OrganizationRedeemCreditCodeAborted_message = new WeakMap();
const ORGANIZATION_GRANT_CREDIT_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationGrantCreditWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_GRANT_CREDIT_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationGrantCreditWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationGrantCreditWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationGrantCreditWorkflowAborted_error.set(this, void 0);
        _OrganizationGrantCreditWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationGrantCreditWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationGrantCreditWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationGrantCreditWorkflowAborted_error, "f");
    }
}
_OrganizationGrantCreditWorkflowAborted_error = new WeakMap(), _OrganizationGrantCreditWorkflowAborted_message = new WeakMap();
const ORGANIZATION_NOTIFY_CREDIT_DEPLETION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationNotifyCreditDepletionAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_NOTIFY_CREDIT_DEPLETION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationNotifyCreditDepletionAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationNotifyCreditDepletionAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationNotifyCreditDepletionAborted_error.set(this, void 0);
        _OrganizationNotifyCreditDepletionAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationNotifyCreditDepletionAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationNotifyCreditDepletionAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationNotifyCreditDepletionAborted_error, "f");
    }
}
_OrganizationNotifyCreditDepletionAborted_error = new WeakMap(), _OrganizationNotifyCreditDepletionAborted_message = new WeakMap();
const ORGANIZATION_UPDATE_SUBSCRIPTION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationUpdateSubscriptionAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_UPDATE_SUBSCRIPTION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationUpdateSubscriptionAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationUpdateSubscriptionAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationUpdateSubscriptionAborted_error.set(this, void 0);
        _OrganizationUpdateSubscriptionAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationUpdateSubscriptionAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationUpdateSubscriptionAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationUpdateSubscriptionAborted_error, "f");
    }
}
_OrganizationUpdateSubscriptionAborted_error = new WeakMap(), _OrganizationUpdateSubscriptionAborted_message = new WeakMap();
const ORGANIZATION_ENQUEUE_WEBHOOK_EVENT_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationEnqueueWebhookEventAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_ENQUEUE_WEBHOOK_EVENT_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationEnqueueWebhookEventAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationEnqueueWebhookEventAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationEnqueueWebhookEventAborted_error.set(this, void 0);
        _OrganizationEnqueueWebhookEventAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationEnqueueWebhookEventAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationEnqueueWebhookEventAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationEnqueueWebhookEventAborted_error, "f");
    }
}
_OrganizationEnqueueWebhookEventAborted_error = new WeakMap(), _OrganizationEnqueueWebhookEventAborted_message = new WeakMap();
const ORGANIZATION_UPDATE_APPLICATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationUpdateApplicationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_UPDATE_APPLICATION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationUpdateApplicationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationUpdateApplicationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationUpdateApplicationAborted_error.set(this, void 0);
        _OrganizationUpdateApplicationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationUpdateApplicationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationUpdateApplicationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationUpdateApplicationAborted_error, "f");
    }
}
_OrganizationUpdateApplicationAborted_error = new WeakMap(), _OrganizationUpdateApplicationAborted_message = new WeakMap();
const ORGANIZATION_UPDATE_CARD_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationUpdateCardAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_UPDATE_CARD_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationUpdateCardAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationUpdateCardAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationUpdateCardAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationUpdateCardAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationUpdateCardAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationUpdateCardAborted_error.set(this, void 0);
        _OrganizationUpdateCardAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationUpdateCardAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationUpdateCardAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationUpdateCardAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationUpdateCardAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationUpdateCardAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationUpdateCardAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationUpdateCardAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationUpdateCardAborted_error, "f");
    }
}
_OrganizationUpdateCardAborted_error = new WeakMap(), _OrganizationUpdateCardAborted_message = new WeakMap();
const ORGANIZATION_UPDATE_CARD_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationUpdateCardWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_UPDATE_CARD_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationUpdateCardWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationUpdateCardWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationUpdateCardWorkflowAborted_error.set(this, void 0);
        _OrganizationUpdateCardWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationUpdateCardWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationUpdateCardWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationUpdateCardWorkflowAborted_error, "f");
    }
}
_OrganizationUpdateCardWorkflowAborted_error = new WeakMap(), _OrganizationUpdateCardWorkflowAborted_message = new WeakMap();
const ORGANIZATION_STRIPE_WEBHOOK_WORKFLOW_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationStripeWebhookWorkflowAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_STRIPE_WEBHOOK_WORKFLOW_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationStripeWebhookWorkflowAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationStripeWebhookWorkflowAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationStripeWebhookWorkflowAborted_error.set(this, void 0);
        _OrganizationStripeWebhookWorkflowAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationStripeWebhookWorkflowAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationStripeWebhookWorkflowAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationStripeWebhookWorkflowAborted_error, "f");
    }
}
_OrganizationStripeWebhookWorkflowAborted_error = new WeakMap(), _OrganizationStripeWebhookWorkflowAborted_message = new WeakMap();
const ORGANIZATION_RECONCILE_WITH_STRIPE_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationReconcileWithStripeAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_RECONCILE_WITH_STRIPE_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationReconcileWithStripeAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationReconcileWithStripeAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationReconcileWithStripeAborted_error.set(this, void 0);
        _OrganizationReconcileWithStripeAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationReconcileWithStripeAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationReconcileWithStripeAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationReconcileWithStripeAborted_error, "f");
    }
}
_OrganizationReconcileWithStripeAborted_error = new WeakMap(), _OrganizationReconcileWithStripeAborted_message = new WeakMap();
const ORGANIZATION_BEGIN_GRACE_PERIOD_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationBeginGracePeriodAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_BEGIN_GRACE_PERIOD_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationBeginGracePeriodAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationBeginGracePeriodAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationBeginGracePeriodAborted_error.set(this, void 0);
        _OrganizationBeginGracePeriodAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationBeginGracePeriodAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationBeginGracePeriodAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationBeginGracePeriodAborted_error, "f");
    }
}
_OrganizationBeginGracePeriodAborted_error = new WeakMap(), _OrganizationBeginGracePeriodAborted_message = new WeakMap();
const ORGANIZATION_END_GRACE_PERIOD_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationEndGracePeriodAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_END_GRACE_PERIOD_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationEndGracePeriodAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationEndGracePeriodAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationEndGracePeriodAborted_error.set(this, void 0);
        _OrganizationEndGracePeriodAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationEndGracePeriodAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationEndGracePeriodAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationEndGracePeriodAborted_error, "f");
    }
}
_OrganizationEndGracePeriodAborted_error = new WeakMap(), _OrganizationEndGracePeriodAborted_message = new WeakMap();
const ORGANIZATION_ENFORCE_GRACE_PERIOD_EXPIRY_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationEnforceGracePeriodExpiryAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_ENFORCE_GRACE_PERIOD_EXPIRY_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationEnforceGracePeriodExpiryAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationEnforceGracePeriodExpiryAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationEnforceGracePeriodExpiryAborted_error.set(this, void 0);
        _OrganizationEnforceGracePeriodExpiryAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationEnforceGracePeriodExpiryAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationEnforceGracePeriodExpiryAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationEnforceGracePeriodExpiryAborted_error, "f");
    }
}
_OrganizationEnforceGracePeriodExpiryAborted_error = new WeakMap(), _OrganizationEnforceGracePeriodExpiryAborted_message = new WeakMap();
const ORGANIZATION_NOTIFY_GRACE_PERIOD_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationNotifyGracePeriodAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_NOTIFY_GRACE_PERIOD_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationNotifyGracePeriodAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationNotifyGracePeriodAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationNotifyGracePeriodAborted_error.set(this, void 0);
        _OrganizationNotifyGracePeriodAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationNotifyGracePeriodAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationNotifyGracePeriodAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationNotifyGracePeriodAborted_error, "f");
    }
}
_OrganizationNotifyGracePeriodAborted_error = new WeakMap(), _OrganizationNotifyGracePeriodAborted_message = new WeakMap();
const ORGANIZATION_NOTIFY_TEAM_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationNotifyTeamAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_NOTIFY_TEAM_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationNotifyTeamAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationNotifyTeamAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationNotifyTeamAborted_error.set(this, void 0);
        _OrganizationNotifyTeamAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationNotifyTeamAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationNotifyTeamAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationNotifyTeamAborted_error, "f");
    }
}
_OrganizationNotifyTeamAborted_error = new WeakMap(), _OrganizationNotifyTeamAborted_message = new WeakMap();
const ORGANIZATION_LIST_APPLICATIONS_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationListApplicationsAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_LIST_APPLICATIONS_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationListApplicationsAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationListApplicationsAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationListApplicationsAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationListApplicationsAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationListApplicationsAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationListApplicationsAborted_error.set(this, void 0);
        _OrganizationListApplicationsAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationListApplicationsAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationListApplicationsAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationListApplicationsAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationListApplicationsAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationListApplicationsAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationListApplicationsAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationListApplicationsAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationListApplicationsAborted_error, "f");
    }
}
_OrganizationListApplicationsAborted_error = new WeakMap(), _OrganizationListApplicationsAborted_message = new WeakMap();
const ORGANIZATION_PIN_APPLICATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
    organization_pb.InvalidOperationError,
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationPinApplicationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_PIN_APPLICATION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationPinApplicationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationPinApplicationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationPinApplicationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationPinApplicationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationPinApplicationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationPinApplicationAborted_error.set(this, void 0);
        _OrganizationPinApplicationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationPinApplicationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationPinApplicationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationPinApplicationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationPinApplicationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationPinApplicationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationPinApplicationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationPinApplicationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationPinApplicationAborted_error, "f");
    }
}
_OrganizationPinApplicationAborted_error = new WeakMap(), _OrganizationPinApplicationAborted_message = new WeakMap();
const ORGANIZATION_UNPIN_APPLICATION_ERROR_TYPES = [
    ...ERROR_TYPES,
    // Method errors.
]; // Need `as const` to ensure TypeScript infers this as a tuple!
export class OrganizationUnpinApplicationAborted extends reboot_api.Aborted {
    static fromStatus(status) {
        let error = reboot_api.errorFromGoogleRpcStatusDetails(status, ORGANIZATION_UNPIN_APPLICATION_ERROR_TYPES);
        if (error !== undefined) {
            return new OrganizationUnpinApplicationAborted(error, { message: status.message });
        }
        error = reboot_api.errorFromGoogleRpcStatusCode(status);
        // TODO(benh): also consider getting the type names from
        // `status.details` and including that in `message` to make
        // debugging easier.
        return new OrganizationUnpinApplicationAborted(error, { message: status.message });
    }
    toStatus() {
        const isObject = (value) => {
            return typeof value === 'object';
        };
        const isArray = (value) => {
            return Array.isArray(value);
        };
        const error = __classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_error, "f").toJson();
        if (!isObject(error) || isArray(error)) {
            throw new Error("Expecting 'error' to be an object (and not an array)");
        }
        const detail = { ...error };
        detail["@type"] = `type.googleapis.com/${__classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_error, "f").getType().typeName}`;
        return new reboot_api.Status({
            code: this.code,
            message: __classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_message, "f"),
            details: [detail]
        });
    }
    constructor(error, { message } = {}) {
        super();
        _OrganizationUnpinApplicationAborted_error.set(this, void 0);
        _OrganizationUnpinApplicationAborted_message.set(this, void 0);
        // Set the name of this error for even more information!
        this.name = this.constructor.name;
        __classPrivateFieldSet(this, _OrganizationUnpinApplicationAborted_error, error, "f");
        let code = reboot_api.grpcStatusCodeFromError(__classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_error, "f"));
        if (code === undefined) {
            // Must be one of the Reboot specific errors.
            code = reboot_api.StatusCode.ABORTED;
        }
        this.code = code;
        __classPrivateFieldSet(this, _OrganizationUnpinApplicationAborted_message, message, "f");
    }
    toString() {
        return `${this.name}: ${this.message}`;
    }
    get message() {
        return `${__classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_error, "f").getType().typeName}${__classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_message, "f") ? ": " + __classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_message, "f") : ""}`;
    }
    get error() {
        reboot_api.assert(__classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_error, "f") instanceof protobuf_es.Message);
        return __classPrivateFieldGet(this, _OrganizationUnpinApplicationAborted_error, "f");
    }
}
_OrganizationUnpinApplicationAborted_error = new WeakMap(), _OrganizationUnpinApplicationAborted_message = new WeakMap();
class OrganizationInstance {
    constructor(id, stateRef, url) {
        this.observers = {};
        this.loadingReaders = 0;
        this.runningMutates = [];
        this.queuedMutates = [];
        this.flushMutates = undefined;
        this.websocket = undefined;
        this.backoff = new reboot_api.Backoff();
        this.useCreateMutations = [];
        this.useCreateSetPendings = {};
        this.useAddMemberMutations = [];
        this.useAddMemberSetPendings = {};
        this.useRemoveMemberMutations = [];
        this.useRemoveMemberSetPendings = {};
        this.useRemoveMemberFromOrgAndUserMutations = [];
        this.useRemoveMemberFromOrgAndUserSetPendings = {};
        this.useUpdateMemberMutations = [];
        this.useUpdateMemberSetPendings = {};
        this.useInviteMemberMutations = [];
        this.useInviteMemberSetPendings = {};
        this.useCancelInviteMutations = [];
        this.useCancelInviteSetPendings = {};
        this.useAcceptInviteMutations = [];
        this.useAcceptInviteSetPendings = {};
        this.useGetPendingInvitesReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.getPendingInvitesFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useGetMembersReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.getMembersFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useGetReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.getFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useAddApplicationMutations = [];
        this.useAddApplicationSetPendings = {};
        this.useRemoveApplicationMutations = [];
        this.useRemoveApplicationSetPendings = {};
        this.useSubscribeMutations = [];
        this.useSubscribeSetPendings = {};
        this.useSetBillingExemptMutations = [];
        this.useSetBillingExemptSetPendings = {};
        this.useSubscriptionReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.subscriptionFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.useRedeemCreditCodeMutations = [];
        this.useRedeemCreditCodeSetPendings = {};
        this.useNotifyCreditDepletionMutations = [];
        this.useNotifyCreditDepletionSetPendings = {};
        this.useUpdateSubscriptionMutations = [];
        this.useUpdateSubscriptionSetPendings = {};
        this.useEnqueueWebhookEventMutations = [];
        this.useEnqueueWebhookEventSetPendings = {};
        this.useUpdateApplicationMutations = [];
        this.useUpdateApplicationSetPendings = {};
        this.useUpdateCardMutations = [];
        this.useUpdateCardSetPendings = {};
        this.useBeginGracePeriodMutations = [];
        this.useBeginGracePeriodSetPendings = {};
        this.useEndGracePeriodMutations = [];
        this.useEndGracePeriodSetPendings = {};
        this.useNotifyGracePeriodMutations = [];
        this.useNotifyGracePeriodSetPendings = {};
        this.useNotifyTeamMutations = [];
        this.useNotifyTeamSetPendings = {};
        this.useListApplicationsReaders = {};
        // `FinalizationRegistry` lets us abort a reader once React has
        // garbage-collected its promise (i.e. abandoned it). It is absent on
        // some runtimes (e.g. React Native's Hermes engine), where we simply
        // skip this cleanup and rely on the `unuse...` timeout path instead.
        this.listApplicationsFinalizationRegistry = typeof FinalizationRegistry !== "undefined"
            ? new FinalizationRegistry((finalize) => finalize())
            : undefined;
        this.usePinApplicationMutations = [];
        this.usePinApplicationSetPendings = {};
        this.useUnpinApplicationMutations = [];
        this.useUnpinApplicationSetPendings = {};
        this.id = id;
        this.stateRef = stateRef;
        this.url = url;
        this.refs = 1;
        // An empty `id` marks the inert instance shared by every no-id
        // caller while no default ID has resolved (e.g. signed out): it
        // opens no socket so there's nothing to connect to.
        if (id !== "") {
            reboot_web.websockets.connect(this.url, this.stateRef);
            this.initializeWebSocket();
        }
    }
    ref() {
        this.refs += 1;
        return this.refs;
    }
    unref() {
        this.refs -= 1;
        if (this.refs === 0 && this.websocket !== undefined) {
            this.websocket.close();
            reboot_web.websockets.disconnect(this.url, this.stateRef);
        }
        return this.refs;
    }
    hasRunningMutations() {
        return this.runningMutates.length > 0;
    }
    async flushMutations() {
        if (this.flushMutates === undefined) {
            this.flushMutates = new reboot_api.Event();
        }
        await this.flushMutates.wait();
    }
    readersLoadedOrFailed() {
        var _a;
        this.flushMutates = undefined;
        if (this.queuedMutates.length > 0) {
            this.runningMutates = this.queuedMutates;
            this.queuedMutates = [];
            if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                for (const { request, update } of this.runningMutates) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
        }
    }
    initializeWebSocket() {
        if (this.websocket === undefined && this.refs > 0 && this.id !== "") {
            const url = new URL(`${this.url}/__/reboot/rpc/${this.stateRef}`);
            url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
            this.websocket = reboot_web.websockets.create(url);
            this.websocket.binaryType = "arraybuffer";
            this.websocket.onopen = () => {
                var _a;
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    for (const { request, update } of this.runningMutates) {
                        update({ isLoading: true });
                        try {
                            this.websocket.send(request.toBinary());
                        }
                        catch (_b) {
                            // We'll retry since we've stored in `*Mutates`.
                        }
                    }
                }
            };
            this.websocket.onerror = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        if (this.runningMutates.length > 0) {
                            console.warn(`[Reboot] WebSocket disconnected, ${this.runningMutates.length} outstanding mutations will be retried when we reconnect`);
                        }
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onclose = async () => {
                if (this.websocket !== undefined) {
                    this.websocket = undefined;
                    for (const { update } of this.runningMutates) {
                        update({ isLoading: false, error: "WebSocket disconnected" });
                    }
                    if (this.refs > 0) {
                        await this.backoff.wait();
                        this.initializeWebSocket();
                    }
                }
            };
            this.websocket.onmessage = async (event) => {
                const { resolve } = this.runningMutates[0];
                this.runningMutates.shift();
                const response = reboot_api.react_pb.MutateResponse.fromBinary(new Uint8Array(event.data));
                resolve(response);
                if (this.flushMutates !== undefined &&
                    this.runningMutates.length === 0) {
                    this.flushMutates.set();
                }
            };
        }
    }
    async mutate(partialRequest, update) {
        const request = partialRequest instanceof reboot_api.react_pb.MutateRequest
            ? partialRequest
            : new reboot_api.react_pb.MutateRequest(partialRequest);
        return new Promise((resolve, _) => {
            var _a;
            if (this.loadingReaders === 0) {
                this.runningMutates = this.runningMutates.concat({ request, resolve, update });
                if (((_a = this.websocket) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN) {
                    update({ isLoading: true });
                    try {
                        this.websocket.send(request.toBinary());
                    }
                    catch (_b) {
                        // We'll retry since we've stored in `*Mutates`.
                    }
                }
            }
            else {
                this.queuedMutates = this.queuedMutates.concat({ request, resolve, update });
            }
        });
    }
    async read(method, serializedRequest, bearerToken, responseType, reader) {
        const queryRequest = new reboot_api.react_pb.QueryRequest({
            method,
            request: serializedRequest,
            ...(bearerToken !== undefined && { bearerToken } || {}),
        });
        let expecteds = [];
        // When we disconnect we may not be able to observe
        // responses due to mutations yet there may still be
        // some outstanding responses that are expected which
        // we treat as "orphans" in the sense that we won't
        // observe their idempotency keys but once we reconnect
        // we will still have observed their effects and can
        // call `observed()` on them.
        let orphans = [];
        const id = `${uuidv4()}`;
        this.observers[id] = {
            observe: (idempotencyKey, observed, aborted) => {
                expecteds = expecteds.concat({ idempotencyKey, observed, aborted });
            },
            unobserve: (idempotencyKey) => {
                expecteds = expecteds.filter(expected => expected.idempotencyKey !== idempotencyKey);
                orphans = orphans.filter(orphan => orphan.idempotencyKey !== idempotencyKey);
            }
        };
        try {
            await reboot_api.retryForever(async () => {
                let loaded = false;
                this.loadingReaders += 1;
                // Any mutations started after we've incremented
                // `this.loadingReaders` will be queued until after
                // all the readers have loaded and thus (1) we know all
                // current `expected` are actually `orphans` that
                // we will haved "observed" once we are (re)connected
                // because we flush mutations before starting to read
                // and (2) all queued mutations can stay in `expected`
                // because we will in fact be able to observe them
                // since they won't get sent over the websocket
                // until after we are (re)connected.
                //
                // NOTE: we need to concatenate with `orphans`
                // because we may try to (re)connect multiple times
                // and between each try more mutations may have been
                // made (or queued ones will be moved to running).
                orphans = [...orphans, ...expecteds];
                expecteds = [];
                try {
                    // Wait for potentially completed mutations to flush
                    // before starting to read so that we read the latest
                    // state including those mutations.
                    if (this.hasRunningMutations()) {
                        await this.flushMutations();
                    }
                    reader.setIsLoading(true);
                    const queryResponses = reboot_web.reactiveReader({
                        endpoint: `${this.url}/__/reboot/rpc/${this.stateRef}`,
                        request: queryRequest,
                        signal: reader.abortController.signal,
                    });
                    for await (const queryResponse of queryResponses) {
                        if (!loaded) {
                            if ((this.loadingReaders -= 1) === 0) {
                                this.readersLoadedOrFailed();
                            }
                            loaded = true;
                        }
                        reader.setIsLoading(false);
                        const response = queryResponse.responseOrStatus.case === "response"
                            ? responseType.fromBinary(queryResponse.responseOrStatus.value)
                            : undefined;
                        // If we were disconnected it must be that we've
                        // observed all `orphans` because we waited
                        // for any mutations to flush before we re-started to
                        // read.
                        const haveOrphans = orphans.length;
                        if (haveOrphans > 0) {
                            // We mark all mutations as observed except the
                            // last one which we also invoke all `setResponse`s.
                            // In this way we effectively create a barrier
                            // for all readers that will synchronize on the last
                            // mutation, but note that this still may lead
                            // to some partial state/response updates because
                            // one reader may have actually received a response
                            // while another reader got disconnected. While this
                            // is likely very rare, it is possible. Mitigating
                            // this issue is non-trivial and for now we have
                            // no plans to address it.
                            for (let i = 0; i < orphans.length - 1; i++) {
                                orphans[i].observed(() => { });
                            }
                            await orphans[orphans.length - 1].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                            });
                            orphans = [];
                        }
                        // We want to check the orphans list AND the expecteds list because
                        // it could be possible that we receive a query response that
                        // contains an idempotency key that we are expecting while having an
                        // orphans list with a length greater than 0. In this case, we don't
                        // want to skip checking the expecteds list just because we have
                        // already checked the orphans list.
                        if (expecteds.length > 0 &&
                            queryResponse.idempotencyKeys.includes(expecteds[0].idempotencyKey)) {
                            await expecteds[0].observed(() => {
                                if (response !== undefined) {
                                    reader.setResponse(response);
                                }
                                expecteds.shift();
                            });
                        }
                        // If we don't have any orphans to observe and we don't have any expecteds to observe,
                        // or at least, the first expecteds _is not observed_ by this response, then go ahead and
                        // pass on the response because it might contain new data that should get shown to the
                        // user (e.g., in a chat room this could be a new message from a different user).
                        else if (response !== undefined && !haveOrphans) {
                            reader.setResponse(response);
                        }
                    }
                    throw new Error('Not expecting stream to ever be done');
                }
                catch (e) {
                    if (!loaded) {
                        if ((this.loadingReaders -= 1) === 0) {
                            this.readersLoadedOrFailed();
                        }
                    }
                    loaded = false;
                    if (reader.abortController.signal.aborted) {
                        for (const { aborted } of [...orphans, ...expecteds]) {
                            aborted();
                        }
                        return;
                    }
                    // Intentionally leave `isLoading: true` here. The outer
                    // `retryForever(...)` will run another attempt and call
                    // `reader.setIsLoading(true)` again at the top of the
                    // try block, but if we cleared it to `false` here first
                    // consumers would observe a brief `false → true → false
                    // → true ...` flip-flop on every retry while we're
                    // actually still trying to (re)connect. Once a response
                    // finally arrives the success path sets it to `false`.
                    if (e instanceof reboot_api.Status) {
                        reader.setStatus(e);
                    }
                    else {
                        console.warn(`[Reboot] Caught unknown exception: ${e instanceof Error ? e.message : JSON.stringify(e)}`);
                    }
                    throw e; // This just retries!
                }
            });
        }
        finally {
            delete this.observers[id];
        }
    }
    async create(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useCreateMutations = this.useCreateMutations.concat(mutation);
        for (const setPending of Object.values(this.useCreateSetPendings)) {
            setPending(this.useCreateMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "Create",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useCreateMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useCreateSetPendings)) {
                        setPending(this.useCreateMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useCreateMutations =
                    this.useCreateMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useCreateSetPendings)) {
                    setPending(this.useCreateMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationCreateResponseFromProtobufShape(organization_pb.CreateResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationCreateAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.Create' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useCreate(id, setPending) {
        this.useCreateSetPendings[id] = setPending;
    }
    unuseCreate(id) {
        delete this.useCreateSetPendings[id];
    }
    async addMember(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useAddMemberMutations = this.useAddMemberMutations.concat(mutation);
        for (const setPending of Object.values(this.useAddMemberSetPendings)) {
            setPending(this.useAddMemberMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "AddMember",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useAddMemberMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useAddMemberSetPendings)) {
                        setPending(this.useAddMemberMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useAddMemberMutations =
                    this.useAddMemberMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useAddMemberSetPendings)) {
                    setPending(this.useAddMemberMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationAddMemberResponseFromProtobufShape(organization_pb.AddMemberResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationAddMemberAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.AddMember' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useAddMember(id, setPending) {
        this.useAddMemberSetPendings[id] = setPending;
    }
    unuseAddMember(id) {
        delete this.useAddMemberSetPendings[id];
    }
    async removeMember(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useRemoveMemberMutations = this.useRemoveMemberMutations.concat(mutation);
        for (const setPending of Object.values(this.useRemoveMemberSetPendings)) {
            setPending(this.useRemoveMemberMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "RemoveMember",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useRemoveMemberMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useRemoveMemberSetPendings)) {
                        setPending(this.useRemoveMemberMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useRemoveMemberMutations =
                    this.useRemoveMemberMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useRemoveMemberSetPendings)) {
                    setPending(this.useRemoveMemberMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationRemoveMemberResponseFromProtobufShape(organization_pb.RemoveMemberResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationRemoveMemberAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.RemoveMember' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useRemoveMember(id, setPending) {
        this.useRemoveMemberSetPendings[id] = setPending;
    }
    unuseRemoveMember(id) {
        delete this.useRemoveMemberSetPendings[id];
    }
    async removeMemberFromOrgAndUser(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useRemoveMemberFromOrgAndUserMutations = this.useRemoveMemberFromOrgAndUserMutations.concat(mutation);
        for (const setPending of Object.values(this.useRemoveMemberFromOrgAndUserSetPendings)) {
            setPending(this.useRemoveMemberFromOrgAndUserMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "RemoveMemberFromOrgAndUser",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useRemoveMemberFromOrgAndUserMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useRemoveMemberFromOrgAndUserSetPendings)) {
                        setPending(this.useRemoveMemberFromOrgAndUserMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useRemoveMemberFromOrgAndUserMutations =
                    this.useRemoveMemberFromOrgAndUserMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useRemoveMemberFromOrgAndUserSetPendings)) {
                    setPending(this.useRemoveMemberFromOrgAndUserMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationRemoveMemberFromOrgAndUserResponseFromProtobufShape(organization_pb.RemoveMemberResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationRemoveMemberFromOrgAndUserAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.RemoveMemberFromOrgAndUser' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useRemoveMemberFromOrgAndUser(id, setPending) {
        this.useRemoveMemberFromOrgAndUserSetPendings[id] = setPending;
    }
    unuseRemoveMemberFromOrgAndUser(id) {
        delete this.useRemoveMemberFromOrgAndUserSetPendings[id];
    }
    async updateMember(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useUpdateMemberMutations = this.useUpdateMemberMutations.concat(mutation);
        for (const setPending of Object.values(this.useUpdateMemberSetPendings)) {
            setPending(this.useUpdateMemberMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "UpdateMember",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useUpdateMemberMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useUpdateMemberSetPendings)) {
                        setPending(this.useUpdateMemberMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useUpdateMemberMutations =
                    this.useUpdateMemberMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useUpdateMemberSetPendings)) {
                    setPending(this.useUpdateMemberMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationUpdateMemberResponseFromProtobufShape(organization_pb.UpdateMemberResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationUpdateMemberAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.UpdateMember' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useUpdateMember(id, setPending) {
        this.useUpdateMemberSetPendings[id] = setPending;
    }
    unuseUpdateMember(id) {
        delete this.useUpdateMemberSetPendings[id];
    }
    async inviteMember(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useInviteMemberMutations = this.useInviteMemberMutations.concat(mutation);
        for (const setPending of Object.values(this.useInviteMemberSetPendings)) {
            setPending(this.useInviteMemberMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "InviteMember",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useInviteMemberMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useInviteMemberSetPendings)) {
                        setPending(this.useInviteMemberMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useInviteMemberMutations =
                    this.useInviteMemberMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useInviteMemberSetPendings)) {
                    setPending(this.useInviteMemberMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationInviteMemberResponseFromProtobufShape(organization_pb.InviteMemberResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationInviteMemberAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.InviteMember' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useInviteMember(id, setPending) {
        this.useInviteMemberSetPendings[id] = setPending;
    }
    unuseInviteMember(id) {
        delete this.useInviteMemberSetPendings[id];
    }
    async cancelInvite(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useCancelInviteMutations = this.useCancelInviteMutations.concat(mutation);
        for (const setPending of Object.values(this.useCancelInviteSetPendings)) {
            setPending(this.useCancelInviteMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "CancelInvite",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useCancelInviteMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useCancelInviteSetPendings)) {
                        setPending(this.useCancelInviteMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useCancelInviteMutations =
                    this.useCancelInviteMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useCancelInviteSetPendings)) {
                    setPending(this.useCancelInviteMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationCancelInviteResponseFromProtobufShape(organization_pb.CancelInviteResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationCancelInviteAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.CancelInvite' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useCancelInvite(id, setPending) {
        this.useCancelInviteSetPendings[id] = setPending;
    }
    unuseCancelInvite(id) {
        delete this.useCancelInviteSetPendings[id];
    }
    async acceptInvite(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useAcceptInviteMutations = this.useAcceptInviteMutations.concat(mutation);
        for (const setPending of Object.values(this.useAcceptInviteSetPendings)) {
            setPending(this.useAcceptInviteMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "AcceptInvite",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useAcceptInviteMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useAcceptInviteSetPendings)) {
                        setPending(this.useAcceptInviteMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useAcceptInviteMutations =
                    this.useAcceptInviteMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useAcceptInviteSetPendings)) {
                    setPending(this.useAcceptInviteMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationAcceptInviteResponseFromProtobufShape(organization_pb.AcceptInviteResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationAcceptInviteAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.AcceptInvite' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useAcceptInvite(id, setPending) {
        this.useAcceptInviteSetPendings[id] = setPending;
    }
    unuseAcceptInvite(id) {
        delete this.useAcceptInviteSetPendings[id];
    }
    startGetPendingInvites(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useGetPendingInvitesReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Organization.GetPendingInvites' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.getPendingInvitesFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useGetPendingInvitesReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useGetPendingInvites(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useGetPendingInvites(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useGetPendingInvitesReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("GetPendingInvites", serializedRequest, bearerToken, organization_pb.GetPendingInvitesResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(organization_pb.GetPendingInvitesResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Organization.GetPendingInvites' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useGetPendingInvites(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startGetPendingInvites(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseGetPendingInvites(id, requestBearerTokenHash) {
        const reader = this.useGetPendingInvitesReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useGetPendingInvitesReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startGetMembers(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useGetMembersReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Organization.GetMembers' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.getMembersFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useGetMembersReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useGetMembers(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useGetMembers(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useGetMembersReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("GetMembers", serializedRequest, bearerToken, organization_pb.GetMembersResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(organization_pb.GetMembersResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Organization.GetMembers' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useGetMembers(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startGetMembers(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseGetMembers(id, requestBearerTokenHash) {
        const reader = this.useGetMembersReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useGetMembersReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useGetReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Organization.Get' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.getFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useGet(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useGet(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useGetReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("Get", serializedRequest, bearerToken, organization_pb.GetResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(organization_pb.GetResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Organization.Get' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseGet(id, requestBearerTokenHash) {
        const reader = this.useGetReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useGetReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    async addApplication(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useAddApplicationMutations = this.useAddApplicationMutations.concat(mutation);
        for (const setPending of Object.values(this.useAddApplicationSetPendings)) {
            setPending(this.useAddApplicationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "AddApplication",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useAddApplicationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useAddApplicationSetPendings)) {
                        setPending(this.useAddApplicationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useAddApplicationMutations =
                    this.useAddApplicationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useAddApplicationSetPendings)) {
                    setPending(this.useAddApplicationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationAddApplicationResponseFromProtobufShape(organization_pb.AddApplicationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationAddApplicationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.AddApplication' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useAddApplication(id, setPending) {
        this.useAddApplicationSetPendings[id] = setPending;
    }
    unuseAddApplication(id) {
        delete this.useAddApplicationSetPendings[id];
    }
    async removeApplication(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useRemoveApplicationMutations = this.useRemoveApplicationMutations.concat(mutation);
        for (const setPending of Object.values(this.useRemoveApplicationSetPendings)) {
            setPending(this.useRemoveApplicationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "RemoveApplication",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useRemoveApplicationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useRemoveApplicationSetPendings)) {
                        setPending(this.useRemoveApplicationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useRemoveApplicationMutations =
                    this.useRemoveApplicationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useRemoveApplicationSetPendings)) {
                    setPending(this.useRemoveApplicationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationRemoveApplicationResponseFromProtobufShape(organization_pb.RemoveApplicationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationRemoveApplicationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.RemoveApplication' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useRemoveApplication(id, setPending) {
        this.useRemoveApplicationSetPendings[id] = setPending;
    }
    unuseRemoveApplication(id) {
        delete this.useRemoveApplicationSetPendings[id];
    }
    async subscribe(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useSubscribeMutations = this.useSubscribeMutations.concat(mutation);
        for (const setPending of Object.values(this.useSubscribeSetPendings)) {
            setPending(this.useSubscribeMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "Subscribe",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useSubscribeMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useSubscribeSetPendings)) {
                        setPending(this.useSubscribeMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useSubscribeMutations =
                    this.useSubscribeMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useSubscribeSetPendings)) {
                    setPending(this.useSubscribeMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationSubscribeResponseFromProtobufShape(organization_pb.SubscribeResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationSubscribeAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.Subscribe' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useSubscribe(id, setPending) {
        this.useSubscribeSetPendings[id] = setPending;
    }
    unuseSubscribe(id) {
        delete this.useSubscribeSetPendings[id];
    }
    async setBillingExempt(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useSetBillingExemptMutations = this.useSetBillingExemptMutations.concat(mutation);
        for (const setPending of Object.values(this.useSetBillingExemptSetPendings)) {
            setPending(this.useSetBillingExemptMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "SetBillingExempt",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useSetBillingExemptMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useSetBillingExemptSetPendings)) {
                        setPending(this.useSetBillingExemptMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useSetBillingExemptMutations =
                    this.useSetBillingExemptMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useSetBillingExemptSetPendings)) {
                    setPending(this.useSetBillingExemptMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationSetBillingExemptResponseFromProtobufShape(organization_pb.SetBillingExemptResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationSetBillingExemptAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.SetBillingExempt' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useSetBillingExempt(id, setPending) {
        this.useSetBillingExemptSetPendings[id] = setPending;
    }
    unuseSetBillingExempt(id) {
        delete this.useSetBillingExemptSetPendings[id];
    }
    startSubscription(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useSubscriptionReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Organization.Subscription' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.subscriptionFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useSubscriptionReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useSubscription(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useSubscription(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useSubscriptionReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("Subscription", serializedRequest, bearerToken, organization_pb.SubscriptionResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(organization_pb.SubscriptionResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Organization.Subscription' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useSubscription(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startSubscription(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseSubscription(id, requestBearerTokenHash) {
        const reader = this.useSubscriptionReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useSubscriptionReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    async redeemCreditCode(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useRedeemCreditCodeMutations = this.useRedeemCreditCodeMutations.concat(mutation);
        for (const setPending of Object.values(this.useRedeemCreditCodeSetPendings)) {
            setPending(this.useRedeemCreditCodeMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "RedeemCreditCode",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useRedeemCreditCodeMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useRedeemCreditCodeSetPendings)) {
                        setPending(this.useRedeemCreditCodeMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useRedeemCreditCodeMutations =
                    this.useRedeemCreditCodeMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useRedeemCreditCodeSetPendings)) {
                    setPending(this.useRedeemCreditCodeMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationRedeemCreditCodeResponseFromProtobufShape(organization_pb.RedeemCreditCodeResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationRedeemCreditCodeAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.RedeemCreditCode' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useRedeemCreditCode(id, setPending) {
        this.useRedeemCreditCodeSetPendings[id] = setPending;
    }
    unuseRedeemCreditCode(id) {
        delete this.useRedeemCreditCodeSetPendings[id];
    }
    async notifyCreditDepletion(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useNotifyCreditDepletionMutations = this.useNotifyCreditDepletionMutations.concat(mutation);
        for (const setPending of Object.values(this.useNotifyCreditDepletionSetPendings)) {
            setPending(this.useNotifyCreditDepletionMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "NotifyCreditDepletion",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useNotifyCreditDepletionMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useNotifyCreditDepletionSetPendings)) {
                        setPending(this.useNotifyCreditDepletionMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useNotifyCreditDepletionMutations =
                    this.useNotifyCreditDepletionMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useNotifyCreditDepletionSetPendings)) {
                    setPending(this.useNotifyCreditDepletionMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationNotifyCreditDepletionResponseFromProtobufShape(organization_pb.NotifyCreditDepletionResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationNotifyCreditDepletionAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.NotifyCreditDepletion' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useNotifyCreditDepletion(id, setPending) {
        this.useNotifyCreditDepletionSetPendings[id] = setPending;
    }
    unuseNotifyCreditDepletion(id) {
        delete this.useNotifyCreditDepletionSetPendings[id];
    }
    async updateSubscription(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useUpdateSubscriptionMutations = this.useUpdateSubscriptionMutations.concat(mutation);
        for (const setPending of Object.values(this.useUpdateSubscriptionSetPendings)) {
            setPending(this.useUpdateSubscriptionMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "UpdateSubscription",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useUpdateSubscriptionMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useUpdateSubscriptionSetPendings)) {
                        setPending(this.useUpdateSubscriptionMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useUpdateSubscriptionMutations =
                    this.useUpdateSubscriptionMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useUpdateSubscriptionSetPendings)) {
                    setPending(this.useUpdateSubscriptionMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationUpdateSubscriptionResponseFromProtobufShape(organization_pb.UpdateSubscriptionResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationUpdateSubscriptionAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.UpdateSubscription' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useUpdateSubscription(id, setPending) {
        this.useUpdateSubscriptionSetPendings[id] = setPending;
    }
    unuseUpdateSubscription(id) {
        delete this.useUpdateSubscriptionSetPendings[id];
    }
    async enqueueWebhookEvent(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useEnqueueWebhookEventMutations = this.useEnqueueWebhookEventMutations.concat(mutation);
        for (const setPending of Object.values(this.useEnqueueWebhookEventSetPendings)) {
            setPending(this.useEnqueueWebhookEventMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "EnqueueWebhookEvent",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useEnqueueWebhookEventMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useEnqueueWebhookEventSetPendings)) {
                        setPending(this.useEnqueueWebhookEventMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useEnqueueWebhookEventMutations =
                    this.useEnqueueWebhookEventMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useEnqueueWebhookEventSetPendings)) {
                    setPending(this.useEnqueueWebhookEventMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationEnqueueWebhookEventResponseFromProtobufShape(organization_pb.EnqueueWebhookEventResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationEnqueueWebhookEventAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.EnqueueWebhookEvent' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useEnqueueWebhookEvent(id, setPending) {
        this.useEnqueueWebhookEventSetPendings[id] = setPending;
    }
    unuseEnqueueWebhookEvent(id) {
        delete this.useEnqueueWebhookEventSetPendings[id];
    }
    async updateApplication(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useUpdateApplicationMutations = this.useUpdateApplicationMutations.concat(mutation);
        for (const setPending of Object.values(this.useUpdateApplicationSetPendings)) {
            setPending(this.useUpdateApplicationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "UpdateApplication",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useUpdateApplicationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useUpdateApplicationSetPendings)) {
                        setPending(this.useUpdateApplicationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useUpdateApplicationMutations =
                    this.useUpdateApplicationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useUpdateApplicationSetPendings)) {
                    setPending(this.useUpdateApplicationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationUpdateApplicationResponseFromProtobufShape(organization_pb.UpdateApplicationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationUpdateApplicationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.UpdateApplication' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useUpdateApplication(id, setPending) {
        this.useUpdateApplicationSetPendings[id] = setPending;
    }
    unuseUpdateApplication(id) {
        delete this.useUpdateApplicationSetPendings[id];
    }
    async updateCard(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useUpdateCardMutations = this.useUpdateCardMutations.concat(mutation);
        for (const setPending of Object.values(this.useUpdateCardSetPendings)) {
            setPending(this.useUpdateCardMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "UpdateCard",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useUpdateCardMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useUpdateCardSetPendings)) {
                        setPending(this.useUpdateCardMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useUpdateCardMutations =
                    this.useUpdateCardMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useUpdateCardSetPendings)) {
                    setPending(this.useUpdateCardMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationUpdateCardResponseFromProtobufShape(organization_pb.UpdateCardResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationUpdateCardAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.UpdateCard' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useUpdateCard(id, setPending) {
        this.useUpdateCardSetPendings[id] = setPending;
    }
    unuseUpdateCard(id) {
        delete this.useUpdateCardSetPendings[id];
    }
    async beginGracePeriod(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useBeginGracePeriodMutations = this.useBeginGracePeriodMutations.concat(mutation);
        for (const setPending of Object.values(this.useBeginGracePeriodSetPendings)) {
            setPending(this.useBeginGracePeriodMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "BeginGracePeriod",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useBeginGracePeriodMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useBeginGracePeriodSetPendings)) {
                        setPending(this.useBeginGracePeriodMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useBeginGracePeriodMutations =
                    this.useBeginGracePeriodMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useBeginGracePeriodSetPendings)) {
                    setPending(this.useBeginGracePeriodMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationBeginGracePeriodResponseFromProtobufShape(organization_pb.BeginGracePeriodResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationBeginGracePeriodAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.BeginGracePeriod' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useBeginGracePeriod(id, setPending) {
        this.useBeginGracePeriodSetPendings[id] = setPending;
    }
    unuseBeginGracePeriod(id) {
        delete this.useBeginGracePeriodSetPendings[id];
    }
    async endGracePeriod(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useEndGracePeriodMutations = this.useEndGracePeriodMutations.concat(mutation);
        for (const setPending of Object.values(this.useEndGracePeriodSetPendings)) {
            setPending(this.useEndGracePeriodMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "EndGracePeriod",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useEndGracePeriodMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useEndGracePeriodSetPendings)) {
                        setPending(this.useEndGracePeriodMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useEndGracePeriodMutations =
                    this.useEndGracePeriodMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useEndGracePeriodSetPendings)) {
                    setPending(this.useEndGracePeriodMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationEndGracePeriodResponseFromProtobufShape(organization_pb.EndGracePeriodResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationEndGracePeriodAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.EndGracePeriod' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useEndGracePeriod(id, setPending) {
        this.useEndGracePeriodSetPendings[id] = setPending;
    }
    unuseEndGracePeriod(id) {
        delete this.useEndGracePeriodSetPendings[id];
    }
    async notifyGracePeriod(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useNotifyGracePeriodMutations = this.useNotifyGracePeriodMutations.concat(mutation);
        for (const setPending of Object.values(this.useNotifyGracePeriodSetPendings)) {
            setPending(this.useNotifyGracePeriodMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "NotifyGracePeriod",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useNotifyGracePeriodMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useNotifyGracePeriodSetPendings)) {
                        setPending(this.useNotifyGracePeriodMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useNotifyGracePeriodMutations =
                    this.useNotifyGracePeriodMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useNotifyGracePeriodSetPendings)) {
                    setPending(this.useNotifyGracePeriodMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationNotifyGracePeriodResponseFromProtobufShape(organization_pb.NotifyGracePeriodResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationNotifyGracePeriodAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.NotifyGracePeriod' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useNotifyGracePeriod(id, setPending) {
        this.useNotifyGracePeriodSetPendings[id] = setPending;
    }
    unuseNotifyGracePeriod(id) {
        delete this.useNotifyGracePeriodSetPendings[id];
    }
    async notifyTeam(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useNotifyTeamMutations = this.useNotifyTeamMutations.concat(mutation);
        for (const setPending of Object.values(this.useNotifyTeamSetPendings)) {
            setPending(this.useNotifyTeamMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "NotifyTeam",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useNotifyTeamMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useNotifyTeamSetPendings)) {
                        setPending(this.useNotifyTeamMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useNotifyTeamMutations =
                    this.useNotifyTeamMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useNotifyTeamSetPendings)) {
                    setPending(this.useNotifyTeamMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationNotifyTeamResponseFromProtobufShape(organization_pb.NotifyTeamResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationNotifyTeamAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.NotifyTeam' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useNotifyTeam(id, setPending) {
        this.useNotifyTeamSetPendings[id] = setPending;
    }
    unuseNotifyTeam(id) {
        delete this.useNotifyTeamSetPendings[id];
    }
    startListApplications(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey) {
        var _a;
        let reader = this.useListApplicationsReaders[requestBearerTokenHash];
        if (reader === undefined) {
            const event = new reboot_api.Event();
            const promise = event.wait();
            reader = {
                abortController: new AbortController(),
                event,
                promise,
                used: false,
                scheduledUnusedTimeoutsCount: 0,
                setResponses: {},
                setIsLoadings: {},
                setStatuses: {},
                setResponse(response, { cache } = { cache: true }) {
                    // Store the response, delete the status.
                    this.response = response;
                    delete this.status;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    // Dispatch to all listeners.
                    for (const setResponse of Object.values(this.setResponses)) {
                        setResponse(response);
                    }
                    // Cache response if applicable.
                    if (cache && offlineCacheEnabled) {
                        reboot_api.assert(cacheKey !== null);
                        const cachedResponse = response.toJsonString();
                        reboot_web.offlineCache().set(cacheKey, cachedResponse)
                            .catch((error) => {
                            console.warn(`[Reboot] Setting of offline reader cache entry for 'Organization.ListApplications' errored with ${error}`);
                        });
                    }
                },
                setIsLoading(isLoading) {
                    for (const setIsLoading of Object.values(this.setIsLoadings)) {
                        setIsLoading(isLoading);
                    }
                },
                setStatus(status) {
                    // Store the status, delete the response.
                    this.status = status;
                    delete this.response;
                    // Trigger response or aborted has been received event (if
                    // it wasn't triggered already).
                    this.event.set();
                    for (const setStatus of Object.values(this.setStatuses)) {
                        setStatus(status);
                    }
                },
            };
            (_a = this.listApplicationsFinalizationRegistry) === null || _a === void 0 ? void 0 : _a.register(promise, () => {
                if (!reader.used) {
                    delete this.useListApplicationsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            });
            // We want to remove the promise so that it can be garbage collected
            // which is our indication that React is no longer using it. But this
            // races with calls to `useListApplications(...)`
            // that might be adding their `setResponse`, `setIsLoading`, etc, so
            // we delay deleting the promise for at least a second.
            //
            // Note that deleting the promise is okay because all subsequent calls
            // will simply use the `reader.response` since it will no longer be
            // undefined.
            reader.promise.then(async () => {
                // Allow the call to `useListApplications(...)`
                // at least 5 seconds to indicate that the reader is being used,
                // afterwhich, once `reader.promise` gets garbage collected
                // we'll know that it must have been abandoned by React, e.g.,
                // because the component was suspended and never committed.
                await reboot_api.sleep({ ms: 5000 });
                delete reader.promise;
            });
            this.useListApplicationsReaders[requestBearerTokenHash] = reader;
            // Start fetching from the server.
            this.read("ListApplications", serializedRequest, bearerToken, organization_pb.ListApplicationsResponse, reader);
            // Check if there is a cached result if applicable.
            if (offlineCacheEnabled) {
                reboot_api.assert(cacheKey !== null);
                reboot_web.offlineCache().get(cacheKey).then((cachedResponse) => {
                    if (cachedResponse !== null) {
                        // We only want to set the response if we haven't already
                        // gotten a response from the server as it is the authority
                        // and should take precedence.
                        if (reader.response === undefined) {
                            reader.setResponse(organization_pb.ListApplicationsResponse.fromJsonString(cachedResponse), { cache: false } // Don't re-cache the value!
                            );
                        }
                    }
                }).catch((error) => {
                    console.warn(`[Reboot] Retrieval of offline reader cache entry for 'Organization.ListApplications' errored with ${error}`);
                });
            }
        }
        reboot_api.assert(reader !== undefined);
        return reader;
    }
    useListApplications(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, setResponse, setIsLoading, setStatus) {
        // We need to call start here because with strict mode the
        // `useEffect` that calls this method will also call "unuse"
        // which will mean the next time the `useEffect` calls here
        // we'll create a new reader in start.
        const reader = this.startListApplications(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        reboot_api.assert(reader !== undefined);
        // Indicate that the reader has properly been used so that we don't
        // clean it up prematurely.
        reader.used = true;
        reader.setResponses[id] = setResponse;
        reader.setIsLoadings[id] = setIsLoading;
        reader.setStatuses[id] = setStatus;
        // If we already have a `response` or `status` need to set it.
        if (reader.response) {
            setResponse(reader.response);
            setIsLoading(false);
        }
        else if (reader.status) {
            setStatus(reader.status);
        }
    }
    unuseListApplications(id, requestBearerTokenHash) {
        const reader = this.useListApplicationsReaders[requestBearerTokenHash];
        reboot_api.assert(reader !== undefined);
        delete reader.setResponses[id];
        delete reader.setIsLoadings[id];
        delete reader.setStatuses[id];
        // Schedule a timeout to delete and abort this reader if we're the
        // last user. We need a timeout because, with StrictMode turned on,
        // we can't remove the reader right away otherwise we won't have a
        // stable Event and Promise. We use 3 seconds but may need to make
        // configurable depending on the application.
        if (Object.values(reader.setResponses).length === 0) {
            reader.scheduledUnusedTimeoutsCount += 1;
            setTimeout(() => {
                reader.scheduledUnusedTimeoutsCount -= 1;
                if (reader.scheduledUnusedTimeoutsCount === 0 &&
                    Object.values(reader.setResponses).length === 0) {
                    delete this.useListApplicationsReaders[requestBearerTokenHash];
                    reader.abortController.abort();
                }
            }, 3000);
        }
    }
    async pinApplication(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.usePinApplicationMutations = this.usePinApplicationMutations.concat(mutation);
        for (const setPending of Object.values(this.usePinApplicationSetPendings)) {
            setPending(this.usePinApplicationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "PinApplication",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.usePinApplicationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.usePinApplicationSetPendings)) {
                        setPending(this.usePinApplicationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.usePinApplicationMutations =
                    this.usePinApplicationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.usePinApplicationSetPendings)) {
                    setPending(this.usePinApplicationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationPinApplicationResponseFromProtobufShape(organization_pb.PinApplicationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationPinApplicationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.PinApplication' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    usePinApplication(id, setPending) {
        this.usePinApplicationSetPendings[id] = setPending;
    }
    unusePinApplication(id) {
        delete this.usePinApplicationSetPendings[id];
    }
    async unpinApplication(mutation) {
        // We always have at least 1 observer which is this function!
        let remainingObservers = 1;
        const event = new reboot_api.Event();
        let callbacks = [];
        const observed = (callback) => {
            callbacks = callbacks.concat(callback);
            remainingObservers -= 1;
            if (remainingObservers === 0) {
                for (const callback of callbacks) {
                    callback();
                }
                event.set();
            }
            return event.wait();
        };
        const aborted = () => {
            observed(() => { });
        };
        // Tell observers about this pending mutation.
        for (const id in this.observers) {
            remainingObservers += 1;
            this.observers[id].observe(mutation.idempotencyKey, observed, aborted);
        }
        this.useUnpinApplicationMutations = this.useUnpinApplicationMutations.concat(mutation);
        for (const setPending of Object.values(this.useUnpinApplicationSetPendings)) {
            setPending(this.useUnpinApplicationMutations);
        }
        return new Promise(async (resolve, reject) => {
            const { responseOrStatus } = await this.mutate({
                method: "UnpinApplication",
                request: mutation.request.toBinary(),
                idempotencyKey: mutation.idempotencyKey,
                bearerToken: mutation.bearerToken,
            }, ({ isLoading, error }) => {
                let rerender = false;
                for (const m of this.useUnpinApplicationMutations) {
                    if (m === mutation) {
                        if (m.isLoading !== isLoading) {
                            m.isLoading = isLoading;
                            rerender = true;
                        }
                        if (error !== undefined && m.error !== error) {
                            m.error = error;
                            rerender = true;
                        }
                    }
                }
                if (rerender) {
                    for (const setPending of Object.values(this.useUnpinApplicationSetPendings)) {
                        setPending(this.useUnpinApplicationMutations);
                    }
                }
            });
            const removeMutationsAndSetPending = () => {
                this.useUnpinApplicationMutations =
                    this.useUnpinApplicationMutations.filter(m => m !== mutation);
                for (const setPending of Object.values(this.useUnpinApplicationSetPendings)) {
                    setPending(this.useUnpinApplicationMutations);
                }
            };
            switch (responseOrStatus.case) {
                case "response": {
                    await observed(() => {
                        removeMutationsAndSetPending();
                        resolve({
                            response: OrganizationUnpinApplicationResponseFromProtobufShape(organization_pb.UnpinApplicationResponse.fromBinary(responseOrStatus.value))
                        });
                    });
                    break;
                }
                case "status": {
                    // Let the observers know they no longer should expect to
                    // observe this idempotency key.
                    for (const id in this.observers) {
                        this.observers[id].unobserve(mutation.idempotencyKey);
                    }
                    const status = reboot_api.Status.fromJsonString(responseOrStatus.value);
                    const aborted = OrganizationUnpinApplicationAborted.fromStatus(status);
                    console.warn(`[Reboot] 'Organization.UnpinApplication' aborted with ${aborted.message}`);
                    removeMutationsAndSetPending();
                    resolve({ aborted });
                    break;
                }
                default: {
                    // TODO(benh): while this is a _really_ fatal error,
                    // should we still set `aborted` instead of throwing?
                    reject(new Error('Expecting either a response or a status'));
                }
            }
        });
    }
    useUnpinApplication(id, setPending) {
        this.useUnpinApplicationSetPendings[id] = setPending;
    }
    unuseUnpinApplication(id) {
        delete this.useUnpinApplicationSetPendings[id];
    }
    static use(id, stateRef, url) {
        if (!(id in this.instances)) {
            this.instances[id] = new OrganizationInstance(id, stateRef, url);
        }
        else {
            this.instances[id].ref();
        }
        return this.instances[id];
    }
    unuse() {
        if (this.unref() === 0) {
            delete OrganizationInstance.instances[this.id];
        }
    }
}
OrganizationInstance.instances = {};
export function useOrganization({ id: providedId } = {}) {
    var _a;
    // Resolve `id` from the frontend-agnostic state-ID map. A `null` map
    // means that resolution is still in flight; an empty map means it
    // resolved with no default ID for us.
    const defaultIds = useDefaultStateIds();
    const isLoading = defaultIds === null;
    // Resolve ID: explicit > URL param (dev) > default-ID map.
    const devId = useMemo(() => {
        // React Native defines `window` but not `window.location`, so both
        // must be checked.
        if (typeof window !== "undefined" &&
            typeof window.location !== "undefined") {
            return new URLSearchParams(window.location.search).get("rbt.cloud.v1alpha1.organization.Organization.id");
        }
        return null;
    }, []);
    const toolInputId = typeof (defaultIds === null || defaultIds === void 0 ? void 0 : defaultIds["rbt.cloud.v1alpha1.organization.Organization"]) === "string"
        ? defaultIds["rbt.cloud.v1alpha1.organization.Organization"]
        : null;
    const resolvedId = (_a = providedId !== null && providedId !== void 0 ? providedId : devId) !== null && _a !== void 0 ? _a : toolInputId;
    // Without a resolved ID we still run every hook below (rules of
    // hooks), binding to the inert empty-ID instance that opens no
    // socket.
    const id = resolvedId !== null && resolvedId !== void 0 ? resolvedId : "";
    // The unresolved no-id case carries an empty `stateRef` rather than
    // computing one. Keyed on the id being unresolved — an explicitly
    // passed empty id still reaches `stateIdToRef`, which rejects it.
    const stateRef = resolvedId == null
        ? ""
        : reboot_api.stateIdToRef("rbt.cloud.v1alpha1.organization.Organization", id);
    const rebootClient = reboot_react.useRebootClient();
    const url = rebootClient.url;
    const bearerToken = rebootClient.bearerToken;
    const refreshBearerToken = useRefreshBearerToken();
    const [instance, setInstance] = useState(() => {
        return OrganizationInstance.use(id, stateRef, url);
    });
    if (instance.id !== id) {
        setInstance(OrganizationInstance.use(id, stateRef, url));
    }
    useEffect(() => {
        return () => {
            instance.unuse();
        };
    }, [instance]);
    const headers = useMemo(() => {
        const headers = new Headers();
        headers.set("Content-Type", "application/json");
        headers.append("Connection", "keep-alive");
        if (bearerToken !== undefined) {
            headers.append("Authorization", `Bearer ${bearerToken}`);
        }
        return headers;
    }, [bearerToken]);
    function useCreate() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useCreate(id, setPending);
            return () => {
                instance.unuseCreate(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const create = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationCreateRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.create(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.create({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        create.pending = pending;
        return create;
    }
    const create = useCreate();
    function useAddMember() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useAddMember(id, setPending);
            return () => {
                instance.unuseAddMember(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const addMember = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationAddMemberRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.addMember(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.addMember({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        addMember.pending = pending;
        return addMember;
    }
    const addMember = useAddMember();
    function useRemoveMember() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useRemoveMember(id, setPending);
            return () => {
                instance.unuseRemoveMember(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const removeMember = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationRemoveMemberRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.removeMember(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.removeMember({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        removeMember.pending = pending;
        return removeMember;
    }
    const removeMember = useRemoveMember();
    function useRemoveMemberFromOrgAndUser() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useRemoveMemberFromOrgAndUser(id, setPending);
            return () => {
                instance.unuseRemoveMemberFromOrgAndUser(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const removeMemberFromOrgAndUser = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationRemoveMemberFromOrgAndUserRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.removeMemberFromOrgAndUser(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.removeMemberFromOrgAndUser({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        removeMemberFromOrgAndUser.pending = pending;
        return removeMemberFromOrgAndUser;
    }
    const removeMemberFromOrgAndUser = useRemoveMemberFromOrgAndUser();
    function useUpdateMember() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useUpdateMember(id, setPending);
            return () => {
                instance.unuseUpdateMember(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const updateMember = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationUpdateMemberRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.updateMember(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.updateMember({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        updateMember.pending = pending;
        return updateMember;
    }
    const updateMember = useUpdateMember();
    function useInviteMember() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useInviteMember(id, setPending);
            return () => {
                instance.unuseInviteMember(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const inviteMember = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationInviteMemberRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.inviteMember(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.inviteMember({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        inviteMember.pending = pending;
        return inviteMember;
    }
    const inviteMember = useInviteMember();
    function useCancelInvite() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useCancelInvite(id, setPending);
            return () => {
                instance.unuseCancelInvite(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const cancelInvite = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationCancelInviteRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.cancelInvite(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.cancelInvite({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        cancelInvite.pending = pending;
        return cancelInvite;
    }
    const cancelInvite = useCancelInvite();
    function useAcceptInvite() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useAcceptInvite(id, setPending);
            return () => {
                instance.unuseAcceptInvite(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const acceptInvite = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationAcceptInviteRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.acceptInvite(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.acceptInvite({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        acceptInvite.pending = pending;
        return acceptInvite;
    }
    const acceptInvite = useAcceptInvite();
    function useGetPendingInvites(partialRequest = {}, options = { suspense: false }) {
        const newRequest = OrganizationGetPendingInvitesRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:GetPendingInvites:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startGetPendingInvites(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && OrganizationGetPendingInvitesResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && OrganizationGetPendingInvitesAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useGetPendingInvites(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(OrganizationGetPendingInvitesResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = OrganizationGetPendingInvitesAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.GetPendingInvites' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseGetPendingInvites(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function getPendingInvites(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = OrganizationGetPendingInvitesRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/GetPendingInvites`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw OrganizationGetPendingInvitesAborted.fromStatus(status);
                        }
                        throw new OrganizationGetPendingInvitesAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof OrganizationGetPendingInvitesAborted) {
                            return { aborted: e };
                        }
                        const aborted = new OrganizationGetPendingInvitesAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.organization.OrganizationMethods.GetPendingInvites\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/GetPendingInvites`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: OrganizationGetPendingInvitesResponseFromProtobufShape((organization_pb.GetPendingInvitesResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new OrganizationGetPendingInvitesAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new OrganizationGetPendingInvitesAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new OrganizationGetPendingInvitesAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/GetPendingInvites`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: OrganizationGetPendingInvitesResponseFromProtobufShape((organization_pb.GetPendingInvitesResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = OrganizationGetPendingInvitesAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.GetPendingInvites' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new OrganizationGetPendingInvitesAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: OrganizationGetPendingInvitesResponseFromProtobufShape((organization_pb.GetPendingInvitesResponse.fromJson(await response.json())))
            };
        }
    }
    function useGetMembers(partialRequest = {}, options = { suspense: false }) {
        const newRequest = OrganizationGetMembersRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:GetMembers:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startGetMembers(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && OrganizationGetMembersResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && OrganizationGetMembersAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useGetMembers(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(OrganizationGetMembersResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = OrganizationGetMembersAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.GetMembers' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseGetMembers(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function getMembers(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = OrganizationGetMembersRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/GetMembers`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw OrganizationGetMembersAborted.fromStatus(status);
                        }
                        throw new OrganizationGetMembersAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof OrganizationGetMembersAborted) {
                            return { aborted: e };
                        }
                        const aborted = new OrganizationGetMembersAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.organization.OrganizationMethods.GetMembers\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/GetMembers`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: OrganizationGetMembersResponseFromProtobufShape((organization_pb.GetMembersResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new OrganizationGetMembersAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new OrganizationGetMembersAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new OrganizationGetMembersAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/GetMembers`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: OrganizationGetMembersResponseFromProtobufShape((organization_pb.GetMembersResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = OrganizationGetMembersAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.GetMembers' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new OrganizationGetMembersAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: OrganizationGetMembersResponseFromProtobufShape((organization_pb.GetMembersResponse.fromJson(await response.json())))
            };
        }
    }
    function useGet(partialRequest = {}, options = { suspense: false }) {
        const newRequest = OrganizationGetRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:Get:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startGet(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && OrganizationGetResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && OrganizationGetAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useGet(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(OrganizationGetResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = OrganizationGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.Get' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseGet(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function get(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = OrganizationGetRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw OrganizationGetAborted.fromStatus(status);
                        }
                        throw new OrganizationGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof OrganizationGetAborted) {
                            return { aborted: e };
                        }
                        const aborted = new OrganizationGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.organization.OrganizationMethods.Get\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/Get`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: OrganizationGetResponseFromProtobufShape((organization_pb.GetResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new OrganizationGetAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new OrganizationGetAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new OrganizationGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/Get`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: OrganizationGetResponseFromProtobufShape((organization_pb.GetResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = OrganizationGetAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.Get' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new OrganizationGetAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: OrganizationGetResponseFromProtobufShape((organization_pb.GetResponse.fromJson(await response.json())))
            };
        }
    }
    function useAddApplication() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useAddApplication(id, setPending);
            return () => {
                instance.unuseAddApplication(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const addApplication = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationAddApplicationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.addApplication(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.addApplication({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        addApplication.pending = pending;
        return addApplication;
    }
    const addApplication = useAddApplication();
    function useRemoveApplication() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useRemoveApplication(id, setPending);
            return () => {
                instance.unuseRemoveApplication(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const removeApplication = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationRemoveApplicationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.removeApplication(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.removeApplication({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        removeApplication.pending = pending;
        return removeApplication;
    }
    const removeApplication = useRemoveApplication();
    function useSubscribe() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useSubscribe(id, setPending);
            return () => {
                instance.unuseSubscribe(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const subscribe = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationSubscribeRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.subscribe(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.subscribe({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        subscribe.pending = pending;
        return subscribe;
    }
    const subscribe = useSubscribe();
    function useSetBillingExempt() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useSetBillingExempt(id, setPending);
            return () => {
                instance.unuseSetBillingExempt(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const setBillingExempt = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationSetBillingExemptRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.setBillingExempt(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.setBillingExempt({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        setBillingExempt.pending = pending;
        return setBillingExempt;
    }
    const setBillingExempt = useSetBillingExempt();
    function useSubscription(partialRequest = {}, options = { suspense: false }) {
        const newRequest = OrganizationSubscriptionRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:Subscription:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startSubscription(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && OrganizationSubscriptionResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && OrganizationSubscriptionAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useSubscription(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(OrganizationSubscriptionResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = OrganizationSubscriptionAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.Subscription' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseSubscription(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function subscription(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = OrganizationSubscriptionRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/Subscription`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw OrganizationSubscriptionAborted.fromStatus(status);
                        }
                        throw new OrganizationSubscriptionAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof OrganizationSubscriptionAborted) {
                            return { aborted: e };
                        }
                        const aborted = new OrganizationSubscriptionAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.organization.OrganizationMethods.Subscription\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/Subscription`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: OrganizationSubscriptionResponseFromProtobufShape((organization_pb.SubscriptionResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new OrganizationSubscriptionAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new OrganizationSubscriptionAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new OrganizationSubscriptionAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/Subscription`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: OrganizationSubscriptionResponseFromProtobufShape((organization_pb.SubscriptionResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = OrganizationSubscriptionAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.Subscription' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new OrganizationSubscriptionAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: OrganizationSubscriptionResponseFromProtobufShape((organization_pb.SubscriptionResponse.fromJson(await response.json())))
            };
        }
    }
    function useRedeemCreditCode() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useRedeemCreditCode(id, setPending);
            return () => {
                instance.unuseRedeemCreditCode(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const redeemCreditCode = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationRedeemCreditCodeRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.redeemCreditCode(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.redeemCreditCode({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        redeemCreditCode.pending = pending;
        return redeemCreditCode;
    }
    const redeemCreditCode = useRedeemCreditCode();
    function useNotifyCreditDepletion() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useNotifyCreditDepletion(id, setPending);
            return () => {
                instance.unuseNotifyCreditDepletion(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const notifyCreditDepletion = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationNotifyCreditDepletionRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.notifyCreditDepletion(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.notifyCreditDepletion({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        notifyCreditDepletion.pending = pending;
        return notifyCreditDepletion;
    }
    const notifyCreditDepletion = useNotifyCreditDepletion();
    function useUpdateSubscription() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useUpdateSubscription(id, setPending);
            return () => {
                instance.unuseUpdateSubscription(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const updateSubscription = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationUpdateSubscriptionRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.updateSubscription(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.updateSubscription({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        updateSubscription.pending = pending;
        return updateSubscription;
    }
    const updateSubscription = useUpdateSubscription();
    function useEnqueueWebhookEvent() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useEnqueueWebhookEvent(id, setPending);
            return () => {
                instance.unuseEnqueueWebhookEvent(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const enqueueWebhookEvent = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationEnqueueWebhookEventRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.enqueueWebhookEvent(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.enqueueWebhookEvent({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        enqueueWebhookEvent.pending = pending;
        return enqueueWebhookEvent;
    }
    const enqueueWebhookEvent = useEnqueueWebhookEvent();
    function useUpdateApplication() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useUpdateApplication(id, setPending);
            return () => {
                instance.unuseUpdateApplication(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const updateApplication = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationUpdateApplicationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.updateApplication(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.updateApplication({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        updateApplication.pending = pending;
        return updateApplication;
    }
    const updateApplication = useUpdateApplication();
    function useUpdateCard() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useUpdateCard(id, setPending);
            return () => {
                instance.unuseUpdateCard(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const updateCard = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationUpdateCardRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.updateCard(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.updateCard({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        updateCard.pending = pending;
        return updateCard;
    }
    const updateCard = useUpdateCard();
    function useBeginGracePeriod() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useBeginGracePeriod(id, setPending);
            return () => {
                instance.unuseBeginGracePeriod(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const beginGracePeriod = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationBeginGracePeriodRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.beginGracePeriod(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.beginGracePeriod({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        beginGracePeriod.pending = pending;
        return beginGracePeriod;
    }
    const beginGracePeriod = useBeginGracePeriod();
    function useEndGracePeriod() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useEndGracePeriod(id, setPending);
            return () => {
                instance.unuseEndGracePeriod(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const endGracePeriod = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationEndGracePeriodRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.endGracePeriod(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.endGracePeriod({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        endGracePeriod.pending = pending;
        return endGracePeriod;
    }
    const endGracePeriod = useEndGracePeriod();
    function useNotifyGracePeriod() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useNotifyGracePeriod(id, setPending);
            return () => {
                instance.unuseNotifyGracePeriod(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const notifyGracePeriod = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationNotifyGracePeriodRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.notifyGracePeriod(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.notifyGracePeriod({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        notifyGracePeriod.pending = pending;
        return notifyGracePeriod;
    }
    const notifyGracePeriod = useNotifyGracePeriod();
    function useNotifyTeam() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useNotifyTeam(id, setPending);
            return () => {
                instance.unuseNotifyTeam(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const notifyTeam = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationNotifyTeamRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.notifyTeam(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.notifyTeam({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        notifyTeam.pending = pending;
        return notifyTeam;
    }
    const notifyTeam = useNotifyTeam();
    function useListApplications(partialRequest = {}, options = { suspense: false }) {
        const newRequest = OrganizationListApplicationsRequestToProtobuf(partialRequest);
        const [request, setRequest] = useState(newRequest);
        const [isLoading, setIsLoading] = useState(true);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const serializedRequest = useMemo(() => request.toBinary(), [request]);
        // To distinguish this call from others when caching responses on
        // the client we compute a "request hash" using SHA256 from the
        // `request`.
        // We memoize this so we don't do it every time.
        const requestHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            return hash.digest().hex();
        }, [serializedRequest]);
        // To create a map of unused readers globally on the client, we
        // compute a "request hash" using SHA256 from the `request`
        // including the bearerToken.
        // We memoize this so we don't do it every time.
        const requestBearerTokenHash = useMemo(() => {
            const hash = reboot_web.calcSha256();
            hash.add(serializedRequest);
            if (bearerToken) {
                hash.add(bearerToken);
            }
            return hash.digest().hex();
        }, [serializedRequest, bearerToken]);
        const offlineCacheEnabled = rebootClient.offlineCacheEnabled;
        const cacheKey = useMemo(() => {
            if (offlineCacheEnabled) {
                return `${stateRef}:ListApplications:${requestHash}`;
            }
            return null;
        }, [stateRef, offlineCacheEnabled, requestHash]);
        // We start reading here, or if another component already started
        // the reading then we just get back the reader. We need to do this
        // before setting up our `useState`s because when using suspense
        // we need to use the `reader.response` or `reader.status` during
        // render where one of them will be defined, i.e., after we've
        // waited for `reader.promise` via `React.use()`.
        const reader = instance.startListApplications(requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey);
        const [response, setResponse] = useState(reader.response && OrganizationListApplicationsResponseFromProtobufShape(reader.response));
        const [aborted, setAborted] = useState(reader.status && OrganizationListApplicationsAborted.fromStatus(reader.status));
        // Track which state ID the current `response` and `aborted` belong
        // to so we can reset them when the state ID changes, back into
        // their "loading" state. We track `id` rather than `instance`
        // because `id` updates immediately from props, whereas `instance`
        // only updates later after a separate `setState`.
        const [responseStateId, setResponseStateId] = useState(id);
        if (responseStateId !== id) {
            setResponseStateId(id);
            setResponse(undefined);
            setAborted(undefined);
            setIsLoading(true);
        }
        useEffect(() => {
            const id = uuidv4();
            instance.useListApplications(id, requestBearerTokenHash, serializedRequest, bearerToken, offlineCacheEnabled, cacheKey, (response) => {
                setAborted(undefined);
                setResponse(OrganizationListApplicationsResponseFromProtobufShape(response));
            }, setIsLoading, (status) => {
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh
                // (the MCP host, or the web session). The token
                // change triggers a re-render and reconnect.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    refreshBearerToken();
                }
                const aborted = OrganizationListApplicationsAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.ListApplications' aborted with ${aborted.message}`);
                setAborted(aborted);
                setResponse(undefined);
            });
            return () => {
                instance.unuseListApplications(id, requestBearerTokenHash);
            };
        }, [
            instance,
            serializedRequest,
            requestBearerTokenHash,
            bearerToken,
            refreshBearerToken,
            offlineCacheEnabled,
            cacheKey,
        ]);
        // If the user has requested suspense via `options.suspense` then
        // we need to use `useMemo` to create a stable promise to pass
        // to `React.use()`. This is important for two reasons:
        //
        // 1. `reader.promise` gets deleted after 5 seconds to
        //    allow GC-based detection of abandoned readers (via
        //    `FinalizationRegistry`), so we can't pass it directly
        //    on every render.
        //
        // 2. `React.use()` suspends at least once for each new
        //    promise it sees (to call `.then()`), so we must
        //    return the same promise across re-renders for a given
        //    reader.
        //
        // When suspense is not requested, or the reader's event is
        // already set (i.e., we have a response or aborted status),
        // we return a pre-resolved promise. Note that `React.use()`
        // will suspend at least once even for a pre-resolved promise
        // in order to set internal state on it, but on subsequent
        // renders it will recognize the same promise and return
        // without suspending.
        //
        // We need to store the suspense promise in a `useRef` so
        // that we can continually return it even if the reader is
        // changing due to things like the `bearerToken` changing,
        // however, we don't want to flicker the suspense fallback
        // when `bearerToken` changes after we've already received
        // a stable `response` (or `aborted`).
        const suspensePromiseRef = useRef(undefined);
        const suspensePromise = useMemo(() => {
            if (suspensePromiseRef.current === undefined || (response === undefined && aborted === undefined)) {
                if (!options.suspense || reader.event.isSet()) {
                    suspensePromiseRef.current = Promise.resolve();
                }
                else {
                    reboot_api.assert(reader.promise !== undefined);
                    reboot_api.assert(response === undefined);
                    reboot_api.assert(aborted === undefined);
                    suspensePromiseRef.current = reader.promise.then(() => { });
                }
            }
            return suspensePromiseRef.current;
        }, [options.suspense, reader, response, aborted]);
        if (options.suspense) {
            if (!("use" in React)) {
                // Raise if it doesn't look like we are using React>=19.
                const error = "In order to pass `suspense: true` to a Reboot reactive reader you must be using React>=19 which provides `React.use`";
                console.error(error);
                throw new Error(error);
            }
            React.use(suspensePromise);
        }
        if (!request.equals(newRequest)) {
            setRequest(newRequest);
            setIsLoading(true);
            return { response, isLoading: true, aborted };
        }
        return { response, isLoading, aborted };
    }
    async function listApplications(partialRequest = {}, options) {
        let retry = true;
        if (options !== undefined && options.retry !== undefined) {
            retry = options.retry;
        }
        const request = OrganizationListApplicationsRequestToProtobuf(partialRequest);
        // Fetch with retry, using a backoff, i.e., if we get disconnected.
        const { response, aborted } = await (async () => {
            var _a;
            const backoff = new reboot_api.Backoff();
            while (true) {
                try {
                    // Invariant here is that we use the '/package.service.method' path and
                    // HTTP 'POST' method (we need 'POST' because we send an HTTP body).
                    //
                    // See also 'reboot/helpers.py'.
                    const response = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/ListApplications`, {
                        ...options,
                        method: "POST",
                        headers,
                        body: request.toJsonString()
                    });
                    // A 'fetch' does not throw on these, so check the status and
                    // retry the same way a failed 'fetch' is retried:
                    // - 502 (Bad Gateway): the proxy can not reach the backend.
                    // - 503 (Unavailable): the server is temporarily unavailable.
                    // - 499 (Cancelled): the request was cancelled, often because
                    //   the server is shutting down.
                    if (response.status === 502 ||
                        response.status === 503 ||
                        response.status === 499) {
                        if (response.headers.get("content-type") === "application/json") {
                            const status = reboot_api.Status.fromJson(await response.json());
                            // Handled in the 'catch' block below.
                            throw OrganizationListApplicationsAborted.fromStatus(status);
                        }
                        throw new OrganizationListApplicationsAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${response.status}`
                        });
                    }
                    return { response };
                }
                catch (e) {
                    if (((_a = options === null || options === void 0 ? void 0 : options.signal) === null || _a === void 0 ? void 0 : _a.aborted) || !retry) {
                        if (e instanceof OrganizationListApplicationsAborted) {
                            return { aborted: e };
                        }
                        const aborted = new OrganizationListApplicationsAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        });
                        return { aborted };
                    }
                    else if (e instanceof Error) {
                        console.error(e);
                    }
                    else {
                        console.error(`[Reboot] Unknown error: ${JSON.stringify(e)}`);
                    }
                }
                await backoff.wait(`[Reboot] Retrying call to \`rbt.cloud.v1alpha1.organization.OrganizationMethods.ListApplications\` with backoff...`);
            }
        })();
        if (aborted) {
            return { aborted };
        }
        else if (response.status === 401 && refreshBearerToken) {
            // Token expired — refresh via the frontend's bearer-refresh
            // and retry once.
            const newToken = await refreshBearerToken();
            if (newToken) {
                const retryHeaders = new Headers();
                retryHeaders.set("Content-Type", "application/json");
                retryHeaders.append("Connection", "keep-alive");
                retryHeaders.append("Authorization", `Bearer ${newToken}`);
                try {
                    const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/ListApplications`, {
                        ...options,
                        method: "POST",
                        headers: retryHeaders,
                        body: request.toJsonString()
                    });
                    if (retryResponse.ok) {
                        return {
                            response: OrganizationListApplicationsResponseFromProtobufShape((organization_pb.ListApplicationsResponse.fromJson(await retryResponse.json())))
                        };
                    }
                    // Fall through to generic error handling on retry failure.
                    return {
                        aborted: new OrganizationListApplicationsAborted(new reboot_api.errors_pb.Unknown(), {
                            message: `Unknown error with HTTP status ${retryResponse.status} after token refresh`
                        })
                    };
                }
                catch (e) {
                    return {
                        aborted: new OrganizationListApplicationsAborted(new reboot_api.errors_pb.Aborted(), {
                            message: e instanceof Error
                                ? `${e}`
                                : `Unknown error: ${JSON.stringify(e)}`
                        })
                    };
                }
            }
            // Refresh failed — fall through to generic error.
            return {
                aborted: new OrganizationListApplicationsAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unauthorized (HTTP 401) and token refresh failed`
                })
            };
        }
        else if (!response.ok) {
            if (response.headers.get("content-type") === "application/json") {
                const status = reboot_api.Status.fromJson(await response.json());
                // If the server rejected us due to an expired
                // token, refresh via the frontend's bearer-refresh and
                // retry once.
                if (status.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken) {
                        const retryHeaders = new Headers();
                        retryHeaders.set("Content-Type", "application/json");
                        retryHeaders.append("Connection", "keep-alive");
                        retryHeaders.append("Authorization", `Bearer ${newToken}`);
                        try {
                            const retryResponse = await reboot_web.guardedFetch(`${rebootClient.url}/__/reboot/rpc/${stateRef}/rbt.cloud.v1alpha1.organization.OrganizationMethods/ListApplications`, {
                                ...options,
                                method: "POST",
                                headers: retryHeaders,
                                body: request.toJsonString()
                            });
                            if (retryResponse.ok) {
                                return {
                                    response: OrganizationListApplicationsResponseFromProtobufShape((organization_pb.ListApplicationsResponse.fromJson(await retryResponse.json())))
                                };
                            }
                        }
                        catch (_a) {
                            // Fall through to return the original aborted error.
                        }
                    }
                }
                const aborted = OrganizationListApplicationsAborted.fromStatus(status);
                console.warn(`[Reboot] 'Organization.ListApplications' aborted with ${aborted.message}`);
                return { aborted };
            }
            else {
                const aborted = new OrganizationListApplicationsAborted(new reboot_api.errors_pb.Unknown(), {
                    message: `Unknown error with HTTP status ${response.status}`
                });
                return { aborted };
            }
        }
        else {
            return {
                response: OrganizationListApplicationsResponseFromProtobufShape((organization_pb.ListApplicationsResponse.fromJson(await response.json())))
            };
        }
    }
    function usePinApplication() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.usePinApplication(id, setPending);
            return () => {
                instance.unusePinApplication(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const pinApplication = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationPinApplicationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.pinApplication(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.pinApplication({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        pinApplication.pending = pending;
        return pinApplication;
    }
    const pinApplication = usePinApplication();
    function useUnpinApplication() {
        const [pending, setPending] = useState([]);
        useEffect(() => {
            const id = uuidv4();
            instance.useUnpinApplication(id, setPending);
            return () => {
                instance.unuseUnpinApplication(id);
            };
        }, [instance]);
        const rebootClient = reboot_react.useRebootClient();
        const bearerToken = rebootClient.bearerToken;
        const unpinApplication = useMemo(() => {
            const method = async (partialRequest = {}, options) => {
                var _a, _b;
                const request = OrganizationUnpinApplicationRequestToProtobuf(partialRequest);
                const idempotencyKey = (_b = (_a = options === null || options === void 0 ? void 0 : options.idempotencyKey) !== null && _a !== void 0 ? _a : options === null || options === void 0 ? void 0 : options.key) !== null && _b !== void 0 ? _b : reboot_web.makeExpiringIdempotencyKey();
                const mutation = {
                    request,
                    idempotencyKey,
                    bearerToken,
                    metadata: options === null || options === void 0 ? void 0 : options.metadata,
                    isLoading: false, // Won't start loading if we're flushing mutations.
                };
                const result = await instance.unpinApplication(mutation);
                // If the server rejected us due to an expired token,
                // refresh via the frontend's bearer-refresh and retry
                // once (mirrors the unary-call path).
                if (result.aborted !== undefined &&
                    result.aborted.code === reboot_api.StatusCode.UNAUTHENTICATED &&
                    refreshBearerToken) {
                    const newToken = await refreshBearerToken();
                    if (newToken !== undefined) {
                        return instance.unpinApplication({ ...mutation, bearerToken: newToken });
                    }
                }
                return result;
            };
            method.pending =
                new Array();
            return method;
        }, [instance, bearerToken, refreshBearerToken]);
        unpinApplication.pending = pending;
        return unpinApplication;
    }
    const unpinApplication = useUnpinApplication();
    // Don't re-render if `id` hasn't changed.
    const api = useMemo(() => ({
        state_id: id,
        mutators: {
            create,
            addMember,
            removeMember,
            removeMemberFromOrgAndUser,
            updateMember,
            inviteMember,
            cancelInvite,
            acceptInvite,
            addApplication,
            removeApplication,
            subscribe,
            setBillingExempt,
            redeemCreditCode,
            notifyCreditDepletion,
            updateSubscription,
            enqueueWebhookEvent,
            updateApplication,
            updateCard,
            beginGracePeriod,
            endGracePeriod,
            notifyGracePeriod,
            notifyTeam,
            pinApplication,
            unpinApplication,
        },
        idempotently: ({ key }) => {
            return {
                create: (partialRequest, options) => create(partialRequest, { ...options, key }),
                addMember: (partialRequest, options) => addMember(partialRequest, { ...options, key }),
                removeMember: (partialRequest, options) => removeMember(partialRequest, { ...options, key }),
                removeMemberFromOrgAndUser: (partialRequest, options) => removeMemberFromOrgAndUser(partialRequest, { ...options, key }),
                updateMember: (partialRequest, options) => updateMember(partialRequest, { ...options, key }),
                inviteMember: (partialRequest, options) => inviteMember(partialRequest, { ...options, key }),
                cancelInvite: (partialRequest, options) => cancelInvite(partialRequest, { ...options, key }),
                acceptInvite: (partialRequest, options) => acceptInvite(partialRequest, { ...options, key }),
                addApplication: (partialRequest, options) => addApplication(partialRequest, { ...options, key }),
                removeApplication: (partialRequest, options) => removeApplication(partialRequest, { ...options, key }),
                subscribe: (partialRequest, options) => subscribe(partialRequest, { ...options, key }),
                setBillingExempt: (partialRequest, options) => setBillingExempt(partialRequest, { ...options, key }),
                redeemCreditCode: (partialRequest, options) => redeemCreditCode(partialRequest, { ...options, key }),
                notifyCreditDepletion: (partialRequest, options) => notifyCreditDepletion(partialRequest, { ...options, key }),
                updateSubscription: (partialRequest, options) => updateSubscription(partialRequest, { ...options, key }),
                enqueueWebhookEvent: (partialRequest, options) => enqueueWebhookEvent(partialRequest, { ...options, key }),
                updateApplication: (partialRequest, options) => updateApplication(partialRequest, { ...options, key }),
                updateCard: (partialRequest, options) => updateCard(partialRequest, { ...options, key }),
                beginGracePeriod: (partialRequest, options) => beginGracePeriod(partialRequest, { ...options, key }),
                endGracePeriod: (partialRequest, options) => endGracePeriod(partialRequest, { ...options, key }),
                notifyGracePeriod: (partialRequest, options) => notifyGracePeriod(partialRequest, { ...options, key }),
                notifyTeam: (partialRequest, options) => notifyTeam(partialRequest, { ...options, key }),
                pinApplication: (partialRequest, options) => pinApplication(partialRequest, { ...options, key }),
                unpinApplication: (partialRequest, options) => unpinApplication(partialRequest, { ...options, key }),
            };
        },
        create,
        addMember,
        removeMember,
        removeMemberFromOrgAndUser,
        updateMember,
        inviteMember,
        cancelInvite,
        acceptInvite,
        getPendingInvites,
        useGetPendingInvites,
        getMembers,
        useGetMembers,
        get,
        useGet,
        addApplication,
        removeApplication,
        subscribe,
        setBillingExempt,
        subscription,
        useSubscription,
        redeemCreditCode,
        notifyCreditDepletion,
        updateSubscription,
        enqueueWebhookEvent,
        updateApplication,
        updateCard,
        beginGracePeriod,
        endGracePeriod,
        notifyGracePeriod,
        notifyTeam,
        listApplications,
        useListApplications,
        pinApplication,
        unpinApplication,
    }), [id, instance, bearerToken, refreshBearerToken]);
    // An explicit `id` caller gets the handle directly; a no-id caller
    // gets the `{ organization, isLoading }`
    // shape, where the handle is `undefined` until a default ID
    // resolves.
    if (providedId !== undefined) {
        return api;
    }
    return {
        organization: resolvedId ? api : undefined,
        isLoading,
    };
}
;
export class Organization {
}
Organization.State = OrganizationProto;
